"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8857],{

/***/ 6606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ CallToAction; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(1056);
;// CONCATENATED MODULE: ./components/content/call-to-action/text-cta.tsx



TextCTA.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    style: (prop_types_default()).string,
    size: (prop_types_default()).string,
    classes: (prop_types_default()).string,
    theme: (prop_types_default()).string
};
function TextCTA(props) {
    var StyleClasses = // console.log({theme})
    function StyleClasses(style, theme) {
        if (theme === "light") {
            return "text-gray-900 underline hover:no-underline";
        } else if (theme === "dark") {
            return "text-white underline hover:no-underline";
        } else {
            return "text-gray-900 underline hover:no-underline";
        }
    };
    var SizeClasses = function SizeClasses(size) {
        if (size === "lg") {
            return "font-medium text-base lg:text-lg";
        } else if (size === "sm") {
            return "font-medium text-sm lg:text-base";
        } else {
            return null;
        }
    };
    var title = props.title, url = props.url, icon = props.icon, type = props.type, style = props.style, size = props.size, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
            url: url,
            classes: "".concat(SizeClasses(size), "\n      ").concat(StyleClasses(style, theme)),
            children: title
        })
    });
}

// EXTERNAL MODULE: ./components/shared/react-icons-wrapper/index.js
var react_icons_wrapper = __webpack_require__(7858);
var react_icons_wrapper_default = /*#__PURE__*/__webpack_require__.n(react_icons_wrapper);
// EXTERNAL MODULE: ./utils/helpers.ts
var helpers = __webpack_require__(949);
;// CONCATENATED MODULE: ./components/content/call-to-action/text-icon-cta.tsx





TextIconCTA.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    style: (prop_types_default()).string,
    size: (prop_types_default()).string,
    classes: (prop_types_default()).string,
    theme: (prop_types_default()).string
};
function TextIconCTA(props) {
    var StyleClasses = function StyleClasses(style, theme) {
        if (style === "primary" && theme === "light") {
            return "text-gray-900";
        } else if (style === "primary" && theme === "dark") {
            return "text-white";
        } else if (style === "secondary" && theme === "light") {
            return "text-gray-900";
        } else if (style === "secondary" && theme === "dark") {
            return "text-white";
        } else {
            return null;
        }
    };
    var SizeClasses = function SizeClasses(size) {
        if (size === "lg") {
            return "font-medium text-base lg:text-lg";
        } else if (size === "sm") {
            return "font-medium text-sm lg:text-base";
        } else {
            return null;
        }
    };
    var title = props.title, url = props.url, icon = props.icon, type = props.type, style = props.style, size = props.size, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
            url: url,
            classes: "".concat(SizeClasses(size), "\n        ").concat(StyleClasses(style, theme)),
            children: [
                title,
                icon && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                    name: (0,helpers/* transformToUpperCase */.n8)(icon, [
                        "-"
                    ]),
                    size: "1.4em",
                    color: "indigo-600",
                    "aria-hidden": "true",
                    className: "inline-block ml-1 text-inherit"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/content/call-to-action/button-cta.tsx



ButtonCTA.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    style: (prop_types_default()).string,
    size: (prop_types_default()).string,
    classes: (prop_types_default()).string,
    theme: (prop_types_default()).string,
    fullWidth: (prop_types_default()).any || false
};
function ButtonCTA(props) {
    var StyleClasses = function StyleClasses(style, theme) {
        if (style === "primary") {
            return "inline-flex items-center justify-center border border-transparent rounded-md shadow-sm bg-brand-2-700 text-white hover:bg-brand-2-500 transition text-center";
        } else if (style === "secondary") {
            return "inline-flex items-center justify-center text-gray-900 border border-gray-300 rounded-md shadow-sm bg-white hover:bg-gray-50 hover:border-gray-400 transition text-center";
        } else if (style === "cta") {
            return "inline-flex items-center justify-center border border-gray-200 rounded-md shadow-sm bg-white hover:bg-gray-50 hover:border-gray-400 transition text-center";
        } else {
            return null;
        }
    };
    var SizeClasses = function SizeClasses(size, type) {
        if (size === "lg" && type === "button") {
            return "font-medium text-base lg:text-lg px-6 py-3";
        }
        if (size === "sm" && type === "button") {
            return "font-medium text-sm lg:text-base px-2.5 py-1.5";
        } else {
            return "font-medium text-sm lg:text-base px-2.5 py-1.5";
        }
    };
    var title = props.title, url = props.url, icon = props.icon, type = props.type, style = props.style, size = props.size, theme = props.theme, fullWidth = props.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
            url: url,
            classes: "".concat(SizeClasses(size, type), "\n      ").concat(StyleClasses(style, theme), " ").concat(fullWidth ? "w-full" : "w-auto"),
            children: title
        })
    });
}

;// CONCATENATED MODULE: ./components/content/call-to-action/button-icon-cta.tsx





ButtonIconCTA.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    style: (prop_types_default()).string,
    size: (prop_types_default()).string,
    classes: (prop_types_default()).string,
    theme: (prop_types_default()).string,
    fullWidth: (prop_types_default()).any || false
};
function ButtonIconCTA(props) {
    var StyleClasses = function StyleClasses(style, theme) {
        if (style === "primary") {
            return "inline-flex items-center justify-center border border-transparent rounded-md shadow-sm bg-brand-2-700 text-white hover:bg-brand-2-500 transition text-center";
        } else if (style === "secondary") {
            return "inline-flex items-center justify-center text-gray-900 border border-gray-200 rounded-md shadow-sm bg-white hover:bg-gray-50 hover:border-gray-400 transition text-center";
        } else if (style === "cta") {
            return "inline-flex items-center justify-center border border-gray-200 rounded-md shadow-sm bg-white hover:bg-gray-50 hover:border-gray-400 transition text-center";
        } else {
            return null;
        }
    };
    var SizeClasses = function SizeClasses(size) {
        if (size === "lg") {
            return "font-medium text-base lg:text-lg pr-4 pl-6 py-3";
        } else if (size === "sm") {
            return "font-medium text-sm lg:text-base pl-2.5 pr-2 py-1.5";
        } else {
            return "font-medium text-base lg:text-lg pr-3.5 pl-4 py-3";
        }
    };
    var title = props.title, url = props.url, icon = props.icon, type = props.type, style = props.style, size = props.size, theme = props.theme, fullWidth = props.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
            url: url,
            classes: "".concat(SizeClasses(size), "\n      ").concat(StyleClasses(style, theme), " ").concat(fullWidth ? "w-full" : "w-auto"),
            children: [
                title,
                icon && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                    name: (0,helpers/* transformToUpperCase */.n8)(icon, [
                        "-"
                    ]),
                    size: "1.2em",
                    color: "gray-700",
                    "aria-hidden": "true",
                    className: "inline-block ml-1"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/content/call-to-action/index.tsx






CallToAction.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    style: (prop_types_default()).string,
    size: (prop_types_default()).string,
    classes: (prop_types_default()).string,
    theme: (prop_types_default()).string,
    fullWidth: (prop_types_default()).any || false
};
function CallToAction(props) {
    var title = props.title, url = props.url, icon = props.icon, type = props.type, style = props.style, size = props.size, theme = props.theme, fullWidth = props.fullWidth;
    if (type === "text") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextCTA, {
            title: title,
            url: url,
            type: type,
            icon: icon,
            style: style,
            size: size,
            theme: theme
        });
    } else if (type === "textIcon") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextIconCTA, {
            title: title,
            url: url,
            type: type,
            icon: icon,
            style: style,
            size: size,
            theme: theme
        });
    } else if (type === "button") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonCTA, {
            title: title,
            url: url,
            type: type,
            icon: icon,
            style: style,
            size: size,
            theme: theme,
            fullWidth: fullWidth
        });
    } else if (type === "buttonIcon") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonIconCTA, {
            title: title,
            url: url,
            type: type,
            icon: icon,
            style: style,
            size: size,
            theme: theme,
            fullWidth: fullWidth
        });
    } else {
        return null;
    }
}


/***/ }),

/***/ 7533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Grid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);

function Grid(param) {
    var gridSize = param.gridSize, children = param.children;
    if (!gridSize) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    } else if (gridSize === 1) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 lg:grid-cols-2 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    } else if (gridSize === 2) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    } else if (gridSize === 4) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    } else if (gridSize % 3 === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    } else if (gridSize % 4 === 2) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 sm:gap-x-8 md:gap-x-12 gap-y-12",
            children: children
        });
    }
}


/***/ }),

/***/ 4894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Hero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_layout_content_components_serializers_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4358);
/* harmony import */ var _components_content_call_to_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6606);
/* harmony import */ var _components_content_tagline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1049);
/* harmony import */ var _components_content_super_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5621);






/*
  Hero Variants
    - side-by-side
    - centered
*/ Hero.propTypes = {
    layout: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    tagline: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().array),
    text: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    primaryLinkText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    primaryLinkUrl: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    primaryLinkIcon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    primaryLinkType: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    secondaryLinkText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    secondaryLinkUrl: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    secondaryLinkIcon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    secondaryLinkType: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    altText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    fullWidth: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    image: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    adjustedHeight: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number)
};
function Hero(props) {
    var layout = props.layout, tagline = props.tagline, title = props.title, text = props.text, primaryLinkText = props.primaryLinkText, primaryLinkUrl = props.primaryLinkUrl, primaryLinkIcon = props.primaryLinkIcon, primaryLinkType = props.primaryLinkType, secondaryLinkText = props.secondaryLinkText, secondaryLinkUrl = props.secondaryLinkUrl, secondaryLinkIcon = props.secondaryLinkIcon, secondaryLinkType = props.secondaryLinkType, altText = props.altText, fullWidth = props.fullWidth, image = props.image, adjustedHeight = props.adjustedHeight;
    var primaryLink = primaryLinkText && primaryLinkUrl ? true : false;
    var secondaryLink = secondaryLinkText && secondaryLinkUrl ? true : false;
    // console.log({adjustedWidth})
    if (layout === "side-by-side") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("section", {
            className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: "flex flex-col grid-cols-12 grid-rows-2 gap-6 overflow-hidden md:grid md:grid-rows-1 lg:gap-6 xl:gap-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "flex order-2 md:order-1 col-span-full md:col-span-6 lg:col-span-5 md:text-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                            children: [
                                tagline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_tagline__WEBPACK_IMPORTED_MODULE_3__/* .Tagline */ .B, {
                                    text: tagline,
                                    size: "md",
                                    classes: "mb-1",
                                    theme: "light"
                                }),
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                    className: "heroTitle",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_content_components_serializers_text__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .x, {
                                        blocks: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                    className: "mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl",
                                    children: text
                                }),
                                (primaryLink || secondaryLink) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                    className: "flex mt-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                        className: "grid items-center gap-6 xl:grid-cols-2",
                                        children: [
                                            primaryLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_call_to_action__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .J, {
                                                title: primaryLinkText,
                                                url: primaryLinkUrl,
                                                type: primaryLinkType,
                                                icon: primaryLinkIcon,
                                                style: "primary",
                                                size: "lg",
                                                theme: primaryLinkType === "textIcon" || primaryLinkType === "text" ? "light" : "dark",
                                                fullWidth: false
                                            }),
                                            secondaryLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_call_to_action__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .J, {
                                                title: secondaryLinkText,
                                                url: secondaryLinkUrl,
                                                type: secondaryLinkType,
                                                icon: secondaryLinkIcon,
                                                style: "secondary",
                                                size: "lg",
                                                theme: "light",
                                                fullWidth: false
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "relative order-1 overflow-hidden md:order-2 col-span-full md:col-span-6 lg:col-span-7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_super_image__WEBPACK_IMPORTED_MODULE_4__/* .SuperImage */ .K, {
                            image: image,
                            imageAltText: altText || "Hero Image",
                            adjustedHeight: adjustedHeight ? adjustedHeight : 520,
                            adjustedWidth: 804,
                            fullWidth: false,
                            classes: "rounded-lg",
                            priority: true
                        })
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("section", {
            className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: "".concat(fullWidth ? "full-width" : "rounded-lg", " relative overflow-hidden"),
                children: [
                    image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: "absolute inset-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "relative w-full h-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_super_image__WEBPACK_IMPORTED_MODULE_4__/* .SuperImage */ .K, {
                                    image: image,
                                    imageAltText: altText || "Hero Image",
                                    adjustedHeight: null,
                                    adjustedWidth: 1920,
                                    fullWidth: true,
                                    classes: "",
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "absolute inset-0 bg-gradient-to-r from-brand-2-900 to-brand-2-200 mix-blend-multiply"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: "absolute inset-0 bg-gradient-to-r from-brand-2-900 to-brand-2-200 mix-blend-multiply"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: "relative max-w-2xl px-4 py-16 mx-auto sm:px-6 sm:py-24 lg:py-32 lg:px-8",
                        children: [
                            tagline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_tagline__WEBPACK_IMPORTED_MODULE_3__/* .Tagline */ .B, {
                                text: tagline,
                                size: "md",
                                theme: "dark",
                                classes: "mb-0 text-center"
                            }),
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "text-center heroTitleDark",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_content_components_serializers_text__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .x, {
                                    blocks: title
                                })
                            }),
                            text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                className: "max-w-lg mx-auto mt-6 text-lg text-center text-gray-100 sm:max-w-3xl md:text-xl lg:text-2xl",
                                children: text
                            }),
                            (primaryLink || secondaryLink) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "mx-auto mt-12 sm:flex sm:justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                    className: "flex flex-col items-center justify-center space-y-4 sm:mx-auto md:flex-row md:space-y-0 md:space-x-4 lg:space-x-8",
                                    children: [
                                        primaryLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_call_to_action__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .J, {
                                            title: primaryLinkText,
                                            url: primaryLinkUrl,
                                            type: primaryLinkType,
                                            icon: primaryLinkIcon,
                                            style: "primary",
                                            size: "lg",
                                            theme: "dark",
                                            fullWidth: false
                                        }),
                                        secondaryLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_content_call_to_action__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .J, {
                                            title: secondaryLinkText,
                                            url: secondaryLinkUrl,
                                            type: secondaryLinkType,
                                            icon: secondaryLinkIcon,
                                            style: "secondary",
                                            size: "lg",
                                            theme: "dark",
                                            fullWidth: false
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}


/***/ }),

/***/ 1056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Linker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function Linker(param) {
    var url = param.url, classes = param.classes, title = param.title, ariaLabel = param.ariaLabel, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // console.log(router.asPath)
    // console.log(router.pathname, url)
    if (!url) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: children
        });
    } else if (url.includes("https") || url.includes("http")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: classes ? classes : "",
            title: title,
            "aria-label": ariaLabel,
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: url,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                className: "".concat(classes ? classes : "", " ").concat(router.asPath === url ? "active" : ""),
                title: title,
                "aria-label": ariaLabel,
                children: children
            })
        });
    }
}


/***/ }),

/***/ 5621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ SuperImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1202);
/* harmony import */ var _lib_sanity_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2377);






function SuperImage(param) {
    var image = param.image, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth, fullWidth = param.fullWidth, classes = param.classes, priority = param.priority;
    // console.log({ image, imageAltText, adjustedHeight, adjustedWidth, fullWidth, classes, priority })
    var imageWidth = function() {
        if (adjustedWidth) {
            return adjustedWidth;
        } else if (fullWidth) {
            return 1920;
        } else {
            return false;
        }
    };
    var imageHeight = function() {
        if (adjustedHeight) {
            return adjustedHeight;
        } else {
            return false;
        }
    };
    var imageFit = function() {
        if (adjustedWidth && adjustedHeight) {
            return "min";
        } else {
            return "clip";
        }
    };
    var myCustomImageBuilder = function(imageUrlBuilder, options) {
        return imageUrlBuilder.width(imageWidth() ? imageWidth() : options.width)//  || Math.min(options.croppedImageDimensions.width, 800)
        .height(imageHeight() ? imageHeight() : options.height).fit(imageFit()).quality(options.quality || 80);
    };
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(_lib_sanity_config__WEBPACK_IMPORTED_MODULE_3__/* .config */ .v, image, {
        imageBuilder: myCustomImageBuilder,
        blurUpImageWidth: 124,
        blurUpImageQuality: 30,
        blurUpAmount: 24
    });
    if (fullWidth) {
        delete imageProps["height"];
        delete imageProps["width"];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
            layout: "fill",
            objectFit: "cover",
            alt: imageAltText || "",
            className: classes,
            priority: true
        }));
    } else if (adjustedHeight || adjustedWidth) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "relative",
            style: "max-width: ".concat(adjustedWidth, "px; width: 100%; height: 100%; max-height: ").concat(adjustedHeight, "px"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
                layout: "responsive",
                sizes: "(max-width: ".concat(adjustedWidth, "px) 100vw, ").concat(adjustedWidth, "px"),
                alt: imageAltText || "",
                className: classes
            }))
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
            layout: "responsive",
            sizes: "(max-width: 800px) 100vw, 800px",
            alt: imageAltText || "",
            className: classes
        }));
    }
}


/***/ }),

/***/ 1049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Tagline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


Tagline.propTypes = {
    text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string) || "md",
    classes: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    theme: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string) || "light"
};
function Tagline(props) {
    var text = props.text, size = props.size, classes = props.classes, theme = props.theme;
    if (!size) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
            className: "mb-1 text-xs font-semibold tracking-widest uppercase title-font ".concat(classes, " ").concat(theme === "light" ? "text-brand-2-800" : "text-white"),
            children: text
        });
    } else if (size === "sm") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
            className: "mb-1 text-xs font-semibold tracking-widest uppercase title-font ".concat(classes, " ").concat(theme === "light" ? "text-brand-2-800" : "text-white"),
            children: text
        });
    } else if (size === "md") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
            className: "text-sm md:text-base font-semibold tracking-wider uppercase ".concat(classes, " ").concat(theme === "light" ? "text-brand-2-800" : "text-white"),
            children: text
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
            className: "mb-1 text-xs font-semibold tracking-widest uppercase title-font ".concat(classes, " ").concat(theme === "light" ? "text-brand-2-800" : "text-white"),
            children: text
        });
    }
}


/***/ }),

/***/ 3301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ ContentComponents; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/content/hero/index.tsx
var hero = __webpack_require__(4894);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./components/content/tagline/index.tsx
var content_tagline = __webpack_require__(1049);
// EXTERNAL MODULE: ./components/shared/react-icons-wrapper/index.js
var react_icons_wrapper = __webpack_require__(7858);
var react_icons_wrapper_default = /*#__PURE__*/__webpack_require__.n(react_icons_wrapper);
// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(1056);
// EXTERNAL MODULE: ./utils/helpers.ts
var helpers = __webpack_require__(949);
// EXTERNAL MODULE: ./components/layout/content-components/serializers/text.js
var serializers_text = __webpack_require__(4358);
;// CONCATENATED MODULE: ./components/content/feature/featurette.tsx






Featurette.propTypes = {
    featuretteStyle: (prop_types_default()).string,
    url: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    icon: (prop_types_default()).any,
    centerAlign: (prop_types_default()) === null || (prop_types_default()) === void 0 ? void 0 : (prop_types_default()).bool
};
var TitleComponent = function(param) {
    var linkUrl = param.linkUrl, title = param.title;
    if (linkUrl) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
            className: "text-lg font-medium tracking-tight text-gray-900",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                url: linkUrl,
                classes: "quickline",
                children: title
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
            className: "text-lg font-medium tracking-tight text-gray-900",
            children: title
        });
    }
};
function Featurette(props) {
    var featuretteStyle = props.featuretteStyle, title = props.title, url = props.url, text = props.text, icon = props.icon, centerAlign = props.centerAlign;
    if (featuretteStyle === "centered") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "pt-4 mt-4 text-center md:mt-6",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "flow-root px-4 pb-8 bg-gray-100 rounded-lg",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "-mt-6",
                    children: [
                        (icon === null || icon === void 0 ? void 0 : icon.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                className: "inline-flex items-center justify-center p-3 rounded-md shadow-lg bg-brand-1-500",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                                    name: (0,helpers/* transformToUpperCase */.n8)(icon === null || icon === void 0 ? void 0 : icon.name, [
                                        "-"
                                    ]),
                                    size: "2em",
                                    color: "white",
                                    "aria-hidden": "true"
                                })
                            })
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TitleComponent, {
                            title: title,
                            linkUrl: url
                        }),
                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                className: "mt-3 text-base prose text-left prose-p:text-gray-600 prose-a:underline hover:prose-a:no-underline",
                                children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            })
                        })
                    ]
                })
            })
        });
    }
    if (featuretteStyle === "side-by-side") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "flow-root text-left",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "flex flex-row",
                children: [
                    (icon === null || icon === void 0 ? void 0 : icon.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "inline-flex items-center justify-center text-brand-1-500",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                                name: (0,helpers/* transformToUpperCase */.n8)(icon === null || icon === void 0 ? void 0 : icon.name, [
                                    "-"
                                ]),
                                size: "2em",
                                "aria-hidden": "true"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "ml-6",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TitleComponent, {
                                title: title,
                                linkUrl: url
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "mt-3 text-base prose text-left prose-p:text-gray-600 prose-a:underline hover:prose-a:no-underline",
                                    children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "flow-root  text-left",
            children: [
                (icon === null || icon === void 0 ? void 0 : icon.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "inline-flex items-center justify-center text-brand-1-500",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                            name: (0,helpers/* transformToUpperCase */.n8)(icon === null || icon === void 0 ? void 0 : icon.name, [
                                "-"
                            ]),
                            size: "2em",
                            "aria-hidden": "true"
                        })
                    })
                }),
                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TitleComponent, {
                    title: title,
                    linkUrl: url
                }),
                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                        className: "mt-3 text-base prose text-left prose-p:text-gray-600 prose-a:underline hover:prose-a:no-underline",
                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                            blocks: text
                        })
                    })
                })
            ]
        });
    }
}

// EXTERNAL MODULE: ./components/content/grid/index.tsx
var grid = __webpack_require__(7533);
;// CONCATENATED MODULE: ./components/content/feature/index.tsx



// import Link from 'next/link';
// import Image from 'next/image';

// import { Linker } from '@/components/content/linker'



Feature.propTypes = {
    layout: (prop_types_default()).string,
    tagline: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    featuretteStyle: (prop_types_default()).string,
    featurettes: (prop_types_default()).array,
    centerAlign: (prop_types_default()).bool
};
function Feature(props) {
    var layout = props.layout, title = props.title, tagline = props.tagline, text = props.text, featuretteStyle = props.featuretteStyle, featurettes = props.featurettes, centerAlign = props.centerAlign;
    if (centerAlign) {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "mx-auto text-center",
                                children: [
                                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                        text: tagline,
                                        size: "md",
                                        theme: "light",
                                        classes: ""
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose text-center md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            featurettes && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: featurettes === null || featurettes === void 0 ? void 0 : featurettes.length,
                                    children: featurettes === null || featurettes === void 0 ? void 0 : featurettes.map(function(feature) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Featurette, {
                                            centerAlign: centerAlign,
                                            featuretteStyle: featuretteStyle,
                                            title: feature.title,
                                            text: feature.text,
                                            url: feature.url,
                                            icon: feature.icon
                                        }, feature._key);
                                    })
                                })
                            })
                        ]
                    })
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: [
                        tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                            text: tagline,
                            size: "md",
                            theme: "light",
                            classes: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative bg-white md:grid md:grid-cols-12 md:gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "max-w-2xl md:col-span-4 md:text-left",
                                    children: [
                                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "prose md:prose-lg lg:prose-xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                                className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                                children: title
                                            })
                                        }),
                                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                            children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                blocks: text
                                            })
                                        })
                                    ]
                                }),
                                featurettes && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "relative mt-12 sm:overflow-hidden sm:mx-auto md:mt-0 md:mx-0 md:col-span-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                        gridSize: 2,
                                        children: featurettes === null || featurettes === void 0 ? void 0 : featurettes.map(function(feature) {
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Featurette, {
                                                centerAlign: centerAlign,
                                                title: feature.title,
                                                text: feature.text,
                                                url: feature.url,
                                                icon: feature.icon,
                                                featuretteStyle: featuretteStyle
                                            }, feature._key);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                                children: [
                                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                        text: tagline,
                                        size: "md",
                                        theme: "light",
                                        classes: ""
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            featurettes && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: featurettes === null || featurettes === void 0 ? void 0 : featurettes.length,
                                    children: featurettes === null || featurettes === void 0 ? void 0 : featurettes.map(function(feature) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Featurette, {
                                            centerAlign: centerAlign,
                                            title: feature.title,
                                            text: feature.text,
                                            url: feature.url,
                                            icon: feature.icon,
                                            featuretteStyle: featuretteStyle
                                        }, feature._key);
                                    })
                                })
                            })
                        ]
                    })
                })
            });
        }
    } else {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md mx-auto text-center sm:max-w-3xl md:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose text-center md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                    children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        featurettes && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                gridSize: featurettes === null || featurettes === void 0 ? void 0 : featurettes.length,
                                children: featurettes === null || featurettes === void 0 ? void 0 : featurettes.map(function(feature) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Featurette, {
                                        centerAlign: centerAlign,
                                        featuretteStyle: featuretteStyle,
                                        title: feature.title,
                                        text: feature.text,
                                        url: feature.url,
                                        icon: feature.icon
                                    }, feature._key);
                                })
                            })
                        })
                    ]
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: [
                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                        text: tagline,
                        size: "md",
                        theme: "light",
                        classes: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white md:grid md:grid-cols-12 md:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-2xl md:col-span-4 md:text-left",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            featurettes && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "relative mt-12 sm:overflow-hidden sm:mx-auto md:mt-0 md:mx-0 md:col-span-8",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: 2,
                                    children: featurettes === null || featurettes === void 0 ? void 0 : featurettes.map(function(feature) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Featurette, {
                                            centerAlign: centerAlign,
                                            title: feature.title,
                                            text: feature.text,
                                            url: feature.url,
                                            icon: feature.icon,
                                            featuretteStyle: featuretteStyle
                                        }, feature._key);
                                    })
                                })
                            })
                        ]
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                    children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        featurettes && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                gridSize: featurettes === null || featurettes === void 0 ? void 0 : featurettes.length,
                                children: featurettes === null || featurettes === void 0 ? void 0 : featurettes.map(function(feature) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Featurette, {
                                        centerAlign: centerAlign,
                                        title: feature.title,
                                        text: feature.text,
                                        url: feature.url,
                                        icon: feature.icon,
                                        featuretteStyle: featuretteStyle
                                    }, feature._key);
                                })
                            })
                        })
                    ]
                })
            });
        }
    }
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/content/call-to-action/index.tsx + 4 modules
var call_to_action = __webpack_require__(6606);
;// CONCATENATED MODULE: ./components/content/card/index.tsx







Card.propTypes = {
    tagline: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    url: (prop_types_default()).string,
    image: (prop_types_default()).string,
    imageBlur: (prop_types_default()).string,
    imageAltText: (prop_types_default()).string,
    callToAction: (prop_types_default()).any,
    centerAlign: (prop_types_default()).bool
};
var ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, url = param.url;
    if (url) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "mb-2",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                url: url,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: image,
                    alt: imageAltText || "",
                    blurDataURL: imageBlur || "",
                    placeholder: imageBlur ? "blur" : "empty",
                    layout: "intrinsic",
                    width: 560,
                    height: 320,
                    className: "block object-cover object-center w-full rounded lg:h-60 xl:h-56 md:h-64 sm:h-72 xs:h-72 h-72 aspect-w-16 aspect-h-9 lg:aspect-none"
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "mb-2",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                src: image,
                alt: imageAltText || "",
                blurDataURL: imageBlur || "",
                placeholder: imageBlur ? "blur" : "empty",
                layout: "intrinsic",
                width: 560,
                height: 320,
                className: "block object-cover object-center w-full rounded lg:h-60 xl:h-56 md:h-64 sm:h-72 xs:h-72 h-72 aspect-w-16 aspect-h-9 lg:aspect-none"
            })
        });
    }
};
var card_TitleComponent = function(param) {
    var title = param.title, url = param.url;
    if (url) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
            className: "inline-block mb-2 text-lg font-medium text-gray-900 title-font",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                url: url,
                classes: "underline decoration-gray-200 underline-offset-4 hover:decoration-gray-600 transition-all decoration-2",
                children: title
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
            className: "inline-block mb-2 text-lg font-medium text-gray-900 title-font",
            children: title
        });
    }
};
function Card(props) {
    var TopMargin = function TopMargin(type) {
        if (type === "buttonIcon" || type === "button") {
            return "mt-4";
        } else {
            return "mt-3";
        }
    };
    var ref;
    var title = props.title, tagline = props.tagline, text = props.text, url = props.url, image = props.image, imageBlur = props.imageBlur, imageAltText = props.imageAltText, callToAction = props.callToAction, centerAlign = props.centerAlign;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "flex flex-col",
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageComponent, {
                image: image,
                imageBlur: imageBlur,
                imageAltText: imageAltText,
                url: url
            }),
            tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                text: tagline,
                size: "sm",
                theme: "light",
                classes: ""
            }),
            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(card_TitleComponent, {
                title: title,
                url: url
            }),
            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    className: "text-base prose text-left prose-p:text-gray-600 prose-a:underline hover:prose-a:no-underline",
                    children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                        blocks: text
                    })
                })
            }),
            callToAction && (callToAction === null || callToAction === void 0 ? void 0 : callToAction.type) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mt-auto",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "".concat(TopMargin(callToAction === null || callToAction === void 0 ? void 0 : callToAction.type)),
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                        title: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title,
                        url: callToAction === null || callToAction === void 0 ? void 0 : callToAction.url,
                        type: callToAction === null || callToAction === void 0 ? void 0 : callToAction.type,
                        icon: callToAction === null || callToAction === void 0 ? void 0 : (ref = callToAction.icon) === null || ref === void 0 ? void 0 : ref.name,
                        style: "cta",
                        size: "sm",
                        theme: "light",
                        fullWidth: false
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@sanity/image-url/lib/browser/image-url.umd.js
var image_url_umd = __webpack_require__(6803);
var image_url_umd_default = /*#__PURE__*/__webpack_require__.n(image_url_umd);
// EXTERNAL MODULE: ./lib/sanity.config.js
var sanity_config = __webpack_require__(2377);
;// CONCATENATED MODULE: ./components/content/card/card-wrapper.tsx


// import Link from 'next/link';
// import Image from 'next/image';

// import { Linker } from '@/components/content/linker'





var builder = image_url_umd_default()(sanity_config/* config */.v);
CardWrapper.propTypes = {
    layout: (prop_types_default()).string,
    tagline: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    cards: (prop_types_default()).array,
    centerAlign: (prop_types_default()).bool
};
function CardWrapper(props) {
    var imageScaled = function(val) {
        return val ? "".concat(builder.image(val).auto("format").width(402).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat(builder.image(val).auto("format").width(10).url()) : null;
    };
    var layout = props.layout, title = props.title, tagline = props.tagline, text = props.text, cards = props.cards, centerAlign = props.centerAlign;
    if (centerAlign) {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "mx-auto text-center",
                                children: [
                                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                        text: tagline,
                                        size: "md",
                                        theme: "light",
                                        classes: ""
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose text-center md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            cards && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: cards === null || cards === void 0 ? void 0 : cards.length,
                                    children: cards.map(function(card) {
                                        var ref, ref1, ref2, ref3, ref4;
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card, {
                                            centerAlign: centerAlign,
                                            title: card === null || card === void 0 ? void 0 : card.title,
                                            tagline: card === null || card === void 0 ? void 0 : card.tagline,
                                            text: card === null || card === void 0 ? void 0 : card.text,
                                            url: card === null || card === void 0 ? void 0 : card.url,
                                            image: imageScaled((ref = card.cardImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset),
                                            imageBlur: imageBlur(card === null || card === void 0 ? void 0 : (ref2 = card.cardImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.asset),
                                            imageAltText: card === null || card === void 0 ? void 0 : (ref4 = card.cardImage) === null || ref4 === void 0 ? void 0 : ref4.alt,
                                            callToAction: card === null || card === void 0 ? void 0 : card.callToAction
                                        }, card._key);
                                    })
                                })
                            })
                        ]
                    })
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: [
                        tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                            text: tagline,
                            size: "md",
                            theme: "light",
                            classes: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative bg-white md:grid md:grid-cols-12 md:gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "max-w-2xl md:col-span-5 md:text-left",
                                    children: [
                                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "prose md:prose-lg lg:prose-xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                                className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                                children: title
                                            })
                                        }),
                                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                            children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                blocks: text
                                            })
                                        })
                                    ]
                                }),
                                cards && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "relative mt-12 sm:overflow-hidden sm:mx-auto md:mt-0 md:mx-0 md:col-span-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                        gridSize: 2,
                                        children: cards.map(function(card) {
                                            var ref, ref1, ref2, ref3, ref4;
                                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card, {
                                                centerAlign: centerAlign,
                                                title: card === null || card === void 0 ? void 0 : card.title,
                                                tagline: card === null || card === void 0 ? void 0 : card.tagline,
                                                text: card === null || card === void 0 ? void 0 : card.text,
                                                url: card === null || card === void 0 ? void 0 : card.url,
                                                image: imageScaled((ref = card.cardImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset),
                                                imageBlur: imageBlur(card === null || card === void 0 ? void 0 : (ref2 = card.cardImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.asset),
                                                imageAltText: card === null || card === void 0 ? void 0 : (ref4 = card.cardImage) === null || ref4 === void 0 ? void 0 : ref4.alt,
                                                callToAction: card === null || card === void 0 ? void 0 : card.callToAction
                                            }, card._key);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                                children: [
                                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                        text: tagline,
                                        size: "md",
                                        theme: "light",
                                        classes: ""
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            cards && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: cards === null || cards === void 0 ? void 0 : cards.length,
                                    children: cards.map(function(card) {
                                        var ref, ref1, ref2, ref3, ref4;
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card, {
                                            centerAlign: centerAlign,
                                            title: card === null || card === void 0 ? void 0 : card.title,
                                            tagline: card === null || card === void 0 ? void 0 : card.tagline,
                                            text: card === null || card === void 0 ? void 0 : card.text,
                                            url: card === null || card === void 0 ? void 0 : card.url,
                                            image: imageScaled((ref = card.cardImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset),
                                            imageBlur: imageBlur(card === null || card === void 0 ? void 0 : (ref2 = card.cardImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.asset),
                                            imageAltText: card === null || card === void 0 ? void 0 : (ref4 = card.cardImage) === null || ref4 === void 0 ? void 0 : ref4.alt,
                                            callToAction: card === null || card === void 0 ? void 0 : card.callToAction
                                        }, card._key);
                                    })
                                })
                            })
                        ]
                    })
                })
            });
        }
    } else {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md mx-auto text-center sm:max-w-3xl md:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose text-center md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                    children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        cards && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                gridSize: cards === null || cards === void 0 ? void 0 : cards.length,
                                children: cards.map(function(card) {
                                    var ref, ref1, ref2, ref3, ref4;
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card, {
                                        centerAlign: centerAlign,
                                        title: card === null || card === void 0 ? void 0 : card.title,
                                        tagline: card === null || card === void 0 ? void 0 : card.tagline,
                                        text: card === null || card === void 0 ? void 0 : card.text,
                                        url: card === null || card === void 0 ? void 0 : card.url,
                                        image: imageScaled((ref = card.cardImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset),
                                        imageBlur: imageBlur(card === null || card === void 0 ? void 0 : (ref2 = card.cardImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.asset),
                                        imageAltText: card === null || card === void 0 ? void 0 : (ref4 = card.cardImage) === null || ref4 === void 0 ? void 0 : ref4.alt,
                                        callToAction: card === null || card === void 0 ? void 0 : card.callToAction
                                    }, card._key);
                                })
                            })
                        })
                    ]
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: [
                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                        text: tagline,
                        size: "md",
                        theme: "light",
                        classes: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white md:grid md:grid-cols-12 md:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-2xl md:col-span-4 md:text-left",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            cards && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "relative mt-12 sm:overflow-hidden sm:mx-auto md:mt-0 md:mx-0 md:col-span-8",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: cards === null || cards === void 0 ? void 0 : cards.length,
                                    children: cards.map(function(card) {
                                        var ref, ref1, ref2, ref3, ref4;
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card, {
                                            centerAlign: centerAlign,
                                            title: card === null || card === void 0 ? void 0 : card.title,
                                            tagline: card === null || card === void 0 ? void 0 : card.tagline,
                                            text: card === null || card === void 0 ? void 0 : card.text,
                                            url: card === null || card === void 0 ? void 0 : card.url,
                                            image: imageScaled((ref = card.cardImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset),
                                            imageBlur: imageBlur(card === null || card === void 0 ? void 0 : (ref2 = card.cardImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.asset),
                                            imageAltText: card === null || card === void 0 ? void 0 : (ref4 = card.cardImage) === null || ref4 === void 0 ? void 0 : ref4.alt,
                                            callToAction: card === null || card === void 0 ? void 0 : card.callToAction
                                        }, card._key);
                                    })
                                })
                            })
                        ]
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                    children: text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        cards && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                gridSize: cards === null || cards === void 0 ? void 0 : cards.length,
                                children: cards.map(function(card) {
                                    var ref, ref1, ref2, ref3, ref4;
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card, {
                                        centerAlign: centerAlign,
                                        title: card === null || card === void 0 ? void 0 : card.title,
                                        tagline: card === null || card === void 0 ? void 0 : card.tagline,
                                        text: card === null || card === void 0 ? void 0 : card.text,
                                        url: card === null || card === void 0 ? void 0 : card.url,
                                        image: imageScaled((ref = card.cardImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset),
                                        imageBlur: imageBlur(card === null || card === void 0 ? void 0 : (ref2 = card.cardImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.asset),
                                        imageAltText: card === null || card === void 0 ? void 0 : (ref4 = card.cardImage) === null || ref4 === void 0 ? void 0 : ref4.alt,
                                        callToAction: card === null || card === void 0 ? void 0 : card.callToAction
                                    }, card._key);
                                })
                            })
                        })
                    ]
                })
            });
        }
    }
}

// EXTERNAL MODULE: ./lib/sanity.js
var sanity = __webpack_require__(8107);
// EXTERNAL MODULE: ./components/layout/content-components/serializers/index.js + 5 modules
var serializers = __webpack_require__(8844);
;// CONCATENATED MODULE: ./components/content/text/index.tsx




TextWrapper.propTypes = {
    body: (prop_types_default()).array.isRequired,
    fullWidth: (prop_types_default()).bool,
    centerAlign: (prop_types_default()).bool
};
function BodyText(param) {
    var blocks = param.blocks;
    // console.log({blocks})
    // TODO: Test this conditional logic out more to make sure it's SOLID
    // && blocks[0]?.children?.length
    return (blocks === null || blocks === void 0 ? void 0 : blocks.length) ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(sanity/* PortableText */.YI, {
        blocks: blocks,
        serializers: serializers/* default */.Z
    }) : null;
}
function TextWrapper(props) {
    var body = props.body, fullWidth = props.fullWidth, centerAlign = props.centerAlign, layout = props.layout;
    // console.log({ body })
    if (layout) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
            className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "relative prose max-w-4xl bg-white md:prose-lg lg:prose-xl prose-h1:first-of-type:mt-0 prose-h2:first-of-type:mt-0  prose-h3:first-of-type:mt-0 prose-h4:first-of-type:mt-0 prose-h5:first-of-type:mt-0 prose-h6:first-of-type:mt-0 ".concat(fullWidth ? "max-w-none" : "", " ").concat(centerAlign ? "mx-auto" : "", " "),
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BodyText, {
                    blocks: body
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "relative prose max-w-4xl bg-white md:prose-lg lg:prose-xl prose-h1:first-of-type:mt-0 prose-h2:first-of-type:mt-0  prose-h3:first-of-type:mt-0 prose-h4:first-of-type:mt-0 prose-h5:first-of-type:mt-0 prose-h6:first-of-type:mt-0 ".concat(fullWidth ? "max-w-none" : "", " ").concat(centerAlign ? "mx-auto  max-w-none" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BodyText, {
                blocks: body
            })
        });
    }
}

// EXTERNAL MODULE: ./node_modules/@sanity/asset-utils/dist/asset-utils.esm.js
var asset_utils_esm = __webpack_require__(1548);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
;// CONCATENATED MODULE: ./components/content/slideshow/index.js






var slideshow_ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "intrinsic",
        width: adjustedWidth,
        height: adjustedHeight,
        className: "object-cover object-center w-full"
    });
};
function Slideshow(props) {
    var adjustedWidth = 896;
    var adjustedHeightVal = function(val) {
        var aspectRatio = (0,asset_utils_esm/* getImageDimensions */.pz)(val === null || val === void 0 ? void 0 : val.asset).aspectRatio;
        return Math.round(896 / aspectRatio);
    };
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeightVal(val)).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
            className: "mb-8 md:mb-12 lg:mb-16",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(js/* Carousel */.lr, {
                showStatus: true,
                dynamicHeight: true,
                swipeable: true,
                showThumbs: false,
                children: props.slides.map(function(slide) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        children: slide.slideImage && slide.slideImage.asset && slide.slideImage.asset._ref && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(slideshow_ImageComponent, {
                            image: imageScaled(slide.slideImage),
                            imageBlur: imageBlur(slide.slideImage),
                            imageAltText: slide.slideImage.title,
                            adjustedWidth: adjustedWidth,
                            adjustedHeight: adjustedHeightVal(slide.slideImage)
                        }, slide._key)
                    }, slide._key);
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/toast/index.tsx
var toast = __webpack_require__(6487);
// EXTERNAL MODULE: ./lib/constants.js
var constants = __webpack_require__(2979);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-recaptcha/dist/react-recaptcha.js
var react_recaptcha = __webpack_require__(5920);
var react_recaptcha_default = /*#__PURE__*/__webpack_require__.n(react_recaptcha);
;// CONCATENATED MODULE: ./components/content/view/contact.js
/* provided dependency */ var process = __webpack_require__(3454);













function Contact(param) {
    var webform = param.webform;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useState)({
        name: "",
        email: "",
        message: "",
        recaptchaResponse: "",
        isVerified: false
    }), query = ref1[0], setQuery = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var notify = compat_module["default"].useCallback(function(type, message) {
        (0,toast/* default */.Z)({
            type: type,
            message: message
        });
    }, []);
    // Google Recaptcha
    var recaptchaLoaded = function recaptchaLoaded() {
        console.log("Recaptcha loaded");
    };
    var expiredCallback = function expiredCallback() {
        console.log("Recaptcha expired");
        setQuery(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                "isVerified": false,
                "recaptchaResponse": null
            });
        });
    };
    var verifyCallback = function verifyCallback(response) {
        if (response) {
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    "isVerified": true,
                    "recaptchaResponse": response
                });
            });
        } else {
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    "isVerified": false,
                    "recaptchaResponse": null
                });
            });
        }
    };
    var handleChange = function() {
        return function(e) {
            var name = e.target.name;
            var value = e.target.value;
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, name, value));
            });
        };
    };
    function googleRecaptcha(formSubmission, axiosConfig) {
        return _googleRecaptcha.apply(this, arguments);
    }
    function _googleRecaptcha() {
        _googleRecaptcha = (0,_async_to_generator/* default */.Z)(function(formSubmission, axiosConfig) {
            var response, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios_default().post("/api/google-recaptcha-v2", formSubmission, axiosConfig)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status >= 400) {
                            throw new Error(response.message);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error1 = _state.sent();
                        throw new Error(constants/* SiteConst.CONTACT_ERROR_MESSAGE */.S.CONTACT_ERROR_MESSAGE);
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _googleRecaptcha.apply(this, arguments);
    }
    ;
    function addMessageToSanity(formSubmission, axiosConfig) {
        return _addMessageToSanity.apply(this, arguments);
    }
    function _addMessageToSanity() {
        _addMessageToSanity = // FIXME: This breaks on production
        (0,_async_to_generator/* default */.Z)(function(formSubmission, axiosConfig) {
            var response, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios_default().post("/api/create-message", formSubmission, axiosConfig)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status >= 400) {
                            throw new Error(response.message);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error1 = _state.sent();
                        throw new Error(constants/* SiteConst.CONTACT_ERROR_MESSAGE */.S.CONTACT_ERROR_MESSAGE);
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _addMessageToSanity.apply(this, arguments);
    }
    ;
    function sendEmailUsingMailgun(formSubmission, axiosConfig) {
        return _sendEmailUsingMailgun.apply(this, arguments);
    }
    function _sendEmailUsingMailgun() {
        _sendEmailUsingMailgun = (0,_async_to_generator/* default */.Z)(function(formSubmission, axiosConfig) {
            var response, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios_default().post("/api/email", formSubmission, axiosConfig)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status >= 400) {
                            throw new Error(response.message);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error1 = _state.sent();
                        throw new Error(constants/* SiteConst.CONTACT_ERROR_MESSAGE */.S.CONTACT_ERROR_MESSAGE);
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _sendEmailUsingMailgun.apply(this, arguments);
    }
    ;
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var formSubmission, axiosConfig, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setIsLoading(true);
                        if (!(query.isVerified && query.name && query.email && query.message)) return [
                            3,
                            6
                        ];
                        formSubmission = (0,_object_spread/* default */.Z)({}, query, webform.formSettings);
                        formSubmission = JSON.parse(JSON.stringify(formSubmission));
                        axiosConfig = {
                            headers: {
                                "Content-Type": "application/json;",
                                "Access-Control-Allow-Origin": "*"
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            googleRecaptcha(formSubmission, axiosConfig)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            sendEmailUsingMailgun(formSubmission, axiosConfig)
                        ];
                    case 3:
                        _state.sent();
                        // FIXME: This breaks on production
                        // await addMessageToSanity(formSubmission, axiosConfig);
                        notify("success", constants/* SiteConst.CONTACT_SUCCESS_MESSAGE */.S.CONTACT_SUCCESS_MESSAGE);
                        setQuery({
                            name: "",
                            email: "",
                            message: ""
                        });
                        setIsLoading(false);
                        if (formSubmission === null || formSubmission === void 0 ? void 0 : formSubmission.thankyou) {
                            router.push(formSubmission.thankyou);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error1 = _state.sent();
                        console.error(error1);
                        notify("error", (error1 === null || error1 === void 0 ? void 0 : error1.message) || constants/* SiteConst.CONTACT_ERROR_MESSAGE */.S.CONTACT_ERROR_MESSAGE);
                        setIsLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        notify("error", (error === null || error === void 0 ? void 0 : error.message) || constants/* SiteConst.CONTACT_ERROR_MESSAGE */.S.CONTACT_ERROR_MESSAGE);
                        setIsLoading(false);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((script_default()), {
                src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
                strategy: "lazyOnload"
            }, "recaptcha"),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("form", {
                className: "grid w-full grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: "name",
                                className: "block text-sm font-medium text-gray-700",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "name",
                                    name: "name",
                                    type: "text",
                                    autoComplete: "name",
                                    required: true,
                                    value: query === null || query === void 0 ? void 0 : query.name,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: "email",
                                className: "block text-sm font-medium text-gray-700",
                                children: "Email address"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    value: query === null || query === void 0 ? void 0 : query.email,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: "message",
                                className: "block text-sm font-medium text-gray-700",
                                children: "Message"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("textarea", {
                                    id: "message",
                                    name: "message",
                                    autoComplete: "message",
                                    required: true,
                                    rows: 5,
                                    value: query === null || query === void 0 ? void 0 : query.message,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "sm:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_recaptcha_default()), {
                            sitekey: process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "6Lf1jNAdAAAAAEPU8oYNBVvJsyVqQOCIU7HjOvoy",
                            render: "explicit",
                            verifyCallback: verifyCallback,
                            onloadCallback: recaptchaLoaded,
                            expiredCallback: expiredCallback,
                            size: "compact"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "sm:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                            type: "submit",
                            className: "flex justify-center w-full md:w-auto px-6 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:border-gray-200 disabled:shadow-none\n            invalid:border-pink-500 invalid:text-pink-600 ".concat(isLoading ? "cursor-not-allowed" : "cursor-pointer"),
                            disabled: isLoading || !query.isVerified || !query.name || !query.email || !query.message || !query.recaptchaResponse,
                            children: isLoading === false ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: "Submit"
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
                                        className: "w-5 h-5 mr-3 -ml-1 text-purple animate-spin",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    " ",
                                    "Loading"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/job-app.js
/* provided dependency */ var job_app_process = __webpack_require__(3454);













function JobApp(param) {
    var webform = param.webform;
    var ref;
    // console.log({ webform })
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useState)({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        positionDesired: "",
        message: "",
        recaptchaResponse: "",
        isVerified: false,
        file: {},
        filename: "",
        createObjectURL: ""
    }), query = ref1[0], setQuery = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var notify = compat_module["default"].useCallback(function(type, message) {
        (0,toast/* default */.Z)({
            type: type,
            message: message
        });
    }, []);
    // Google Recaptcha
    var recaptchaLoaded = function recaptchaLoaded() {
        console.log("Recaptcha loaded");
    };
    var expiredCallback = function expiredCallback() {
        console.log("Recaptcha expired");
        setQuery(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                "isVerified": false,
                "recaptchaResponse": null
            });
        });
    };
    var verifyCallback = function verifyCallback(response1) {
        if (response1) {
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    "isVerified": true,
                    "recaptchaResponse": response1
                });
            });
        } else {
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    "isVerified": false,
                    "recaptchaResponse": null
                });
            });
        }
    };
    var handleChange = function() {
        return function(e) {
            var name = e.target.name;
            var value = e.target.value;
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, name, value));
            });
        };
    };
    var fileSelectedHandler = function(e) {
        if (e.target.files && e.target.files[0]) {
            var i = e.target.files[0];
            // console.log({i})
            if (i.type !== "application/pdf") {
                notify("error", "Please upload only PDF files");
                setQuery(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        "file": "",
                        "filename": "",
                        "createObjectURL": ""
                    });
                });
                return;
            }
            if (i.size > 2600000) {
                notify("error", "Please upload a smaller PDF. Under 2.5MB");
                setQuery(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        "file": "",
                        "filename": "",
                        "createObjectURL": ""
                    });
                });
                return;
            }
            var dateTime = Date.now();
            var fileName = "".concat(dateTime, "-").concat(i.name);
            setQuery(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    "file": i,
                    "filename": fileName,
                    "createObjectURL": URL.createObjectURL(i)
                });
            });
        }
    };
    function googleRecaptcha(formSubmission, axiosConfig) {
        return _googleRecaptcha.apply(this, arguments);
    }
    function _googleRecaptcha() {
        _googleRecaptcha = (0,_async_to_generator/* default */.Z)(function(formSubmission, axiosConfig) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            axios_default().post("/api/google-recaptcha-v2", formSubmission, axiosConfig)
                        ];
                    case 1:
                        _state.sent();
                        if (response.status >= 400) {
                            throw new Error(response.message);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        throw new Error(constants/* SiteConst.CONTACT_ERROR_MESSAGE */.S.CONTACT_ERROR_MESSAGE);
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _googleRecaptcha.apply(this, arguments);
    }
    ;
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var formData, config, ref, error, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setIsLoading(true);
                        formData = new FormData();
                        formData.append("emailfrom", webform.formSettings.emailfrom);
                        formData.append("emailto", webform.formSettings.emailto);
                        formData.append("subject", webform.formSettings.subject);
                        formData.append("firstName", query.firstName);
                        formData.append("lastName", query.lastName);
                        formData.append("phone", query.phone);
                        formData.append("email", query.email);
                        formData.append("positionDesired", query.positionDesired);
                        formData.append("message", query.message);
                        formData.append("filename", query.filename);
                        formData.append("file", query.file);
                        config = {
                            headers: {
                                "content-type": "multipart/form-data"
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().post("/api/upload-and-email", formData, config).then(function(res) {
                                console.log(res.data);
                                console.log(query.filename);
                                console.log(formData);
                            })
                        ];
                    case 2:
                        _state.sent();
                        notify("success", "Thank you. Your resume has been sent.");
                        setQuery({
                            firstName: "",
                            lastName: "",
                            phone: "",
                            email: "",
                            positionDesired: "",
                            message: "",
                            recaptchaResponse: "",
                            isVerified: false,
                            file: {},
                            filename: "",
                            createObjectURL: ""
                        });
                        setIsLoading(false);
                        if (webform === null || webform === void 0 ? void 0 : (ref = webform.formSettings) === null || ref === void 0 ? void 0 : ref.thankyou) {
                            router.push(webform.formSettings.thankyou);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        // console.log({error})
                        // throw new Error(SiteConst.CONTACT_ERROR_MESSAGE);
                        notify("error", (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "There has been an error with your submission. Please refresh your page and try again.");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((script_default()), {
                src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
                strategy: "lazyOnload"
            }, "recaptcha"),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("form", {
                className: "grid w-full grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("label", {
                                htmlFor: "firstName",
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    "First Name ",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "font-extrabold text-red-700",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "firstName",
                                    name: "firstName",
                                    type: "text",
                                    autoComplete: "given-name",
                                    required: true,
                                    value: query === null || query === void 0 ? void 0 : query.firstName,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("label", {
                                htmlFor: "lastName",
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    "Last Name ",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "font-extrabold text-red-700",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "lastName",
                                    name: "lastName",
                                    type: "text",
                                    autoComplete: "family-name",
                                    required: true,
                                    value: query === null || query === void 0 ? void 0 : query.lastName,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("label", {
                                htmlFor: "email",
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    "Email address ",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "font-extrabold text-red-700",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    value: query === null || query === void 0 ? void 0 : query.email,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("label", {
                                htmlFor: "phone",
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    "Phone Number ",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "font-extrabold text-red-700",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "phone",
                                    name: "phone",
                                    type: "tel",
                                    autoComplete: "phone",
                                    required: true,
                                    value: query === null || query === void 0 ? void 0 : query.phone,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: "positionDesired",
                                className: "block text-sm font-medium text-gray-700",
                                children: "Position Desired"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    id: "positionDesired",
                                    name: "positionDesired",
                                    type: "text",
                                    autoComplete: "positionDesired",
                                    // required
                                    value: query === null || query === void 0 ? void 0 : query.positionDesired,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: "message",
                                className: "block text-sm font-medium text-gray-700",
                                children: "Message"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("textarea", {
                                    id: "message",
                                    name: "message",
                                    autoComplete: "message",
                                    rows: 5,
                                    value: query === null || query === void 0 ? void 0 : query.message,
                                    onChange: handleChange(),
                                    className: "block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "sm:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("label", {
                                htmlFor: "name",
                                className: "block text-sm font-medium text-gray-700",
                                children: [
                                    "Upload Your Resume (pdf) ",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "font-extrabold text-red-700",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                    className: "form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
                                    type: "file",
                                    id: "file",
                                    onChange: function(e) {
                                        return fileSelectedHandler(e);
                                    },
                                    required: true,
                                    accept: ".pdf, application/pdf"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "sm:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_recaptcha_default()), {
                            sitekey: job_app_process === null || job_app_process === void 0 ? void 0 : (ref = job_app_process.env) === null || ref === void 0 ? void 0 : "6Lf1jNAdAAAAAEPU8oYNBVvJsyVqQOCIU7HjOvoy",
                            render: "explicit",
                            verifyCallback: verifyCallback,
                            onloadCallback: recaptchaLoaded,
                            expiredCallback: expiredCallback,
                            size: "compact"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "sm:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                            type: "submit",
                            className: "flex justify-center w-full md:w-auto px-6 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:border-gray-200 disabled:shadow-none\n            invalid:border-pink-500 invalid:text-pink-600 ".concat(isLoading ? "cursor-not-allowed" : "cursor-pointer"),
                            disabled: isLoading || !query.isVerified || !query.firstName || !query.lastName || !query.phone || !query.email || !query.recaptchaResponse || !query.file || !query.createObjectURL,
                            children: isLoading === false ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: "Submit"
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
                                        className: "w-5 h-5 mr-3 -ml-1 text-purple animate-spin",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    " ",
                                    "Loading"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/content-view/aside.tsx



Aside.propTypes = {
    tags: (prop_types_default()).array,
    categories: (prop_types_default()).array
};
function Aside(props) {
    var tags = props.tags, categories = props.categories, type = props.type;
    var filteredCats = categories === null || categories === void 0 ? void 0 : categories.filter(function(val) {
        return val.count > 0;
    }).sort(function(a, b) {
        return a.title > b.title ? 1 : -1;
    }).filter(Boolean);
    var filteredTags = tags === null || tags === void 0 ? void 0 : tags.filter(function(val) {
        return val.count > 0;
    }).sort(function(a, b) {
        return a.title > b.title ? 1 : -1;
    }).filter(Boolean);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            filteredCats.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                className: "mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h4", {
                        className: "block pb-2 mb-4 text-sm font-medium tracking-widest text-gray-500 uppercase border-b-2 title-font border-b-gray-100",
                        children: "Categories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "block p-0 m-0",
                        children: filteredCats.filter(function(val) {
                            return val.count > 0;
                        }).map(function(category) {
                            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("li", {
                                className: "flex justify-between w-full mb-4 text-base align-baseline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/".concat(type, "/category/").concat(category.slug),
                                        classes: "hover:text-indigo-600",
                                        children: category === null || category === void 0 ? void 0 : category.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "inline-block px-2 py-1 mr-1 text-xs font-semibold text-pink-600 uppercase bg-pink-200 rounded-full last:mr-0",
                                        children: category === null || category === void 0 ? void 0 : category.count
                                    })
                                ]
                            }, category._id);
                        })
                    })
                ]
            }),
            filteredTags.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h4", {
                        className: "block pb-2 mb-4 text-sm font-medium tracking-widest text-gray-500 uppercase border-b-2 border-b-gray-100",
                        children: "Tags"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "block p-0 m-0",
                        children: filteredTags.filter(function(val) {
                            return val.count > 0;
                        }).map(function(tag) {
                            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("li", {
                                className: "flex justify-between w-full mb-4 text-base align-baseline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/".concat(type, "/tag/").concat(tag.slug),
                                        classes: "hover:text-indigo-600",
                                        children: tag === null || tag === void 0 ? void 0 : tag.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "inline-block px-2 py-1 mr-1 text-xs font-semibold text-pink-600 uppercase bg-pink-200 rounded-full last:mr-0",
                                        children: tag === null || tag === void 0 ? void 0 : tag.count
                                    })
                                ]
                            }, tag._id);
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(4850);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
;// CONCATENATED MODULE: ./components/content/view/content-view/blog-view.tsx








var blog_view_ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "responsive",
        width: adjustedWidth,
        height: adjustedHeight,
        // className="object-cover object-center w-full"
        className: "object-cover object-center w-full transition-all duration-500 lg:h-48 md:h-36 hover:scale-110"
    });
};
function Figure(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 615;
    var adjustedHeight = 300;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(blog_view_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
function FigureLarge(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 918;
    var adjustedHeight = 448;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(blog_view_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
BlogView.propTypes = {
    data: (prop_types_default()).array
};
function BlogView(props) {
    var data = props.data;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            data === null || data === void 0 ? void 0 : data.map(function(post) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("article", {
                    className: "flex flex-col mb-12 overflow-hidden rounded-md shadow-md",
                    children: [
                        (post === null || post === void 0 ? void 0 : post.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative flex-shrink-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FigureLarge, (0,_object_spread/* default */.Z)({}, post.mainImage))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                                        dateTime: post.publishedAt.utc,
                                        children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative flex-shrink-0 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                                        className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                                        dateTime: post.publishedAt.utc,
                                        children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex-1",
                                children: [
                                    (post === null || post === void 0 ? void 0 : (ref = post.category) === null || ref === void 0 ? void 0 : ref.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                        className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                            url: "".concat( true ? "/blog" : 0, "/category/").concat(post.category.slug),
                                            classes: "hover:underline",
                                            children: post.category.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "mt-2 mb-1 text-2xl font-semibold text-gray-900",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                            href: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                            className: "hover:underline",
                                            children: [
                                                "  ",
                                                post.title
                                            ]
                                        })
                                    }),
                                    post.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                        className: "text-lg text-gray-500",
                                        children: post.summary
                                    })
                                ]
                            })
                        })
                    ]
                }, post._id);
            }).shift(),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                gridSize: 2,
                children: data === null || data === void 0 ? void 0 : data.slice(1).map(function(post) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("article", {
                        className: "flex flex-col overflow-hidden rounded-md shadow-md",
                        children: [
                            (post === null || post === void 0 ? void 0 : post.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "relative flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Figure, (0,_object_spread/* default */.Z)({}, post.mainImage))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                                            dateTime: post.publishedAt.utc,
                                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "relative flex-shrink-0 overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                                            className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                                            dateTime: post.publishedAt.utc,
                                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "flex-1",
                                    children: [
                                        (post === null || post === void 0 ? void 0 : (ref = post.category) === null || ref === void 0 ? void 0 : ref.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                url: "".concat( true ? "/blog" : 0, "/category/").concat(post.category.slug),
                                                classes: "hover:underline",
                                                children: post.category.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "mt-2 mb-1 text-xl font-semibold text-gray-900",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                                href: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                                className: "hover:underline",
                                                children: [
                                                    "  ",
                                                    post.title
                                                ]
                                            })
                                        }),
                                        post.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-base text-gray-500",
                                            children: post.summary
                                        })
                                    ]
                                })
                            })
                        ]
                    }, post._id);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
;// CONCATENATED MODULE: ./components/content/event/cal-icon/index.tsx


function CalIcon(param) {
    var startDate = param.startDate;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "absolute font-medium shadow-xl min-w-20 xl:min-w-24 min-h-48 top-4 right-4",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "flex-none w-20 text-center rounded-t xl:w-24 lg:rounded-t-none lg:rounded-l ",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "block overflow-hidden text-center rounded-t ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "py-1 text-sm text-white xl:text-base bg-brand-1-700",
                        children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(startDate), "MMM Y")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "pt-1 bg-white border-l border-r border-white",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "text-3xl font-bold leading-tight xl:text-4xl",
                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(startDate), "do")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "-mb-1 text-center bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "text-sm",
                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(startDate), "EEEE")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "pb-2 text-center bg-white border-white rounded-b-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "text-xs leading-normal",
                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(startDate), "p")
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ExclamationIcon.js
var ExclamationIcon = __webpack_require__(3772);
;// CONCATENATED MODULE: ./components/content/view/content-view/events-view.tsx










var events_view_ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "responsive",
        width: adjustedWidth,
        height: adjustedHeight,
        // className="object-cover object-center w-full"
        className: "object-cover object-center w-full transition-all duration-500 lg:h-48 md:h-36 hover:scale-110"
    });
};
function events_view_Figure(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 615;
    var adjustedHeight = 300;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(events_view_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
function events_view_FigureLarge(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 918;
    var adjustedHeight = 448;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(events_view_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
EventsView.propTypes = {
    data: (prop_types_default()).array
};
function EventsView(props) {
    var data = props.data;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            data === null || data === void 0 ? void 0 : data.map(function(event) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("article", {
                    className: "flex flex-col mb-12 overflow-hidden rounded-md shadow-md",
                    children: [
                        (event === null || event === void 0 ? void 0 : event.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative flex-shrink-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(events_view_FigureLarge, (0,_object_spread/* default */.Z)({}, event === null || event === void 0 ? void 0 : event.mainImage))
                                }),
                                (event === null || event === void 0 ? void 0 : (ref = event.startDate) === null || ref === void 0 ? void 0 : ref.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalIcon, {
                                        startDate: event === null || event === void 0 ? void 0 : (ref1 = event.startDate) === null || ref1 === void 0 ? void 0 : ref1.utc
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative flex-shrink-0 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                                        className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                                    })
                                }),
                                (event === null || event === void 0 ? void 0 : (ref2 = event.startDate) === null || ref2 === void 0 ? void 0 : ref2.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalIcon, {
                                        startDate: event === null || event === void 0 ? void 0 : (ref3 = event.startDate) === null || ref3 === void 0 ? void 0 : ref3.utc
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "space-y-2 md:space-y-0 md:flex md:justify-between md:flex-row",
                                        children: [
                                            (event === null || event === void 0 ? void 0 : (ref4 = event.category) === null || ref4 === void 0 ? void 0 : ref4.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                                className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/events/category/".concat(event.category.slug),
                                                    classes: "hover:underline",
                                                    children: event.category.title
                                                })
                                            }),
                                            !(0,isBefore/* default */.Z)(new Date(), new Date((0,parseISO/* default */.Z)(event === null || event === void 0 ? void 0 : (ref5 = event.startDate) === null || ref5 === void 0 ? void 0 : ref5.utc))) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                                className: "md:ml-auto inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-red-600 text-white space-x-2 flex uppercase",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExclamationIcon/* default */.Z, {
                                                        className: "w-4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                        children: "Past Event"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "mt-2 mb-1 text-4xl font-semibold text-gray-900",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                            href: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                            className: "hover:underline",
                                            children: [
                                                "  ",
                                                event.title
                                            ]
                                        })
                                    }),
                                    event.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                        className: "text-xl text-gray-500",
                                        children: event.summary
                                    })
                                ]
                            })
                        })
                    ]
                }, event._id);
            }).shift(),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                gridSize: 2,
                children: data === null || data === void 0 ? void 0 : data.slice(1).map(function(event) {
                    var ref, ref1, ref2, ref3, ref4;
                    /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("article", {
                        className: "flex flex-col overflow-hidden rounded-md shadow-md",
                        children: [
                            (event === null || event === void 0 ? void 0 : event.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "relative flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(events_view_Figure, (0,_object_spread/* default */.Z)({}, event === null || event === void 0 ? void 0 : event.mainImage))
                                    }),
                                    (event === null || event === void 0 ? void 0 : (ref = event.startDate) === null || ref === void 0 ? void 0 : ref.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalIcon, {
                                            startDate: event === null || event === void 0 ? void 0 : (ref1 = event.startDate) === null || ref1 === void 0 ? void 0 : ref1.utc
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "relative flex-shrink-0 overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                                            className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                                        })
                                    }),
                                    (event === null || event === void 0 ? void 0 : (ref2 = event.startDate) === null || ref2 === void 0 ? void 0 : ref2.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalIcon, {
                                            startDate: event === null || event === void 0 ? void 0 : (ref3 = event.startDate) === null || ref3 === void 0 ? void 0 : ref3.utc
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "flex-1",
                                    children: [
                                        (event === null || event === void 0 ? void 0 : (ref4 = event.category) === null || ref4 === void 0 ? void 0 : ref4.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                url: "/events/category/".concat(event.category.slug),
                                                classes: "hover:underline",
                                                children: event.category.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "mt-2 mb-1 text-2xl font-semibold text-gray-900",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                                href: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                                className: "hover:underline",
                                                children: [
                                                    "  ",
                                                    event.title
                                                ]
                                            })
                                        }),
                                        event.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-base text-gray-500",
                                            children: event.summary
                                        })
                                    ]
                                })
                            })
                        ]
                    }, event._id);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/content-view/index.tsx





ContentView.propTypes = {
    view: (prop_types_default()).object
};
function ContentView(props) {
    var view = props.view;
    var tags = view.tags, categories = view.categories;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "grid grid-cols-1 gap-6 mt-8 lg:grid-flow-col-dense lg:grid-cols-4 sm:gap-x-8 md:gap-x-12 gap-y-12",
        children: [
            categories && tags && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "top-0 lg:max-h-screen lg:sticky lg:col-start-4 lg:col-span-1",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Aside, {
                    tags: tags,
                    categories: categories,
                    type: (view === null || view === void 0 ? void 0 : view.events) && "events" || ((view === null || view === void 0 ? void 0 : view.posts) && ( true ? "/blog" : 0)).replace("/", "")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "space-y-6 lg:col-start-1 lg:col-span-3",
                children: [
                    (view === null || view === void 0 ? void 0 : view.posts) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BlogView, {
                        data: view === null || view === void 0 ? void 0 : view.posts
                    }),
                    (view === null || view === void 0 ? void 0 : view.events) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventsView, {
                        data: view === null || view === void 0 ? void 0 : view.events
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/team/index.tsx








var team_ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "responsive",
        width: adjustedWidth,
        height: adjustedHeight,
        className: "overflow-hidden transition-all duration-500 rounded-full lg:h-24 md:h-24"
    });
};
function team_Figure(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 195;
    var adjustedHeight = 195;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(team_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
function team_FigureLarge(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 918;
    var adjustedHeight = 448;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat(urlFor(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat(urlFor(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ _jsx("figure", {
        children: /*#__PURE__*/ _jsx(team_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
TeamView.propTypes = {
    data: (prop_types_default()).array
};
function GroupComponent(param) {
    var people = param.people;
    var TeamLength = (people === null || people === void 0 ? void 0 : people.length) || 3;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "mx-auto mt-4 space-y-16 sm:grid sm:grid-cols-2 sm:gap-8 sm:space-y-0 lg:gap-8 md:grid-cols-3 lg:max-w-4xl md:mt-6",
        children: people === null || people === void 0 ? void 0 : people.map(function(person) {
            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("article", {
                className: "flex flex-col items-center mb-12",
                children: [
                    (person === null || person === void 0 ? void 0 : person.headshot) ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "relative flex-shrink-0 w-52",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                            url: "/profile/".concat(person.slug),
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(team_Figure, (0,_object_spread/* default */.Z)({}, person.headshot))
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "relative flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                            className: "w-48 h-48 rounded-full bg-gradient-to-r from-brand-1-800 to-brand-2-800"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex flex-col items-center px-6 pt-4 pb-6 bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex-1 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "mb-1 text-2xl font-semibold text-gray-900 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                            href: "/profile/".concat(person.slug),
                                            className: "hover:underline",
                                            children: person.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h4", {
                                        className: "text-gray-500",
                                        children: person.proTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                className: "pt-3 pb-0",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
                                    url: "/profile/".concat(person.slug),
                                    classes: "text-base font-semibold text-indigo-600 hover:text-indigo-500 flex items-center",
                                    children: [
                                        "View Profile",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
                                            className: "w-4 h-4 ml-2",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            fill: "none",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                    d: "M5 12h14"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                    d: "M12 5l7 7-7 7"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, person._id);
        })
    });
}
function TeamView(props) {
    var groups = (props === null || props === void 0 ? void 0 : props.view).groups;
    // lg:max-w-4xl
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        children: groups.map(function(group) {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "mb-10 md:mb-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                        className: "mx-auto text-3xl font-bold md:text-4xl lg:text-6xl lg:max-w-4xl",
                        children: group.title
                    }),
                    (group === null || group === void 0 ? void 0 : (ref = group.body) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = group === null || group === void 0 ? void 0 : group.body[0]) === null || ref1 === void 0 ? void 0 : ref1.children.length) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "mx-auto mt-4 mb-12 text-base text-gray-500 md:text-lg lg:text-xl lg:max-w-4xl",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(sanity/* PortableText */.YI, {
                            blocks: group === null || group === void 0 ? void 0 : group.body,
                            serializers: serializers/* default */.Z
                        })
                    }),
                    (group === null || group === void 0 ? void 0 : group.people) && (group === null || group === void 0 ? void 0 : group.people.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupComponent, {
                        people: group.people
                    })
                ]
            }, group._id);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/groq/lib/groq.js
var groq = __webpack_require__(114);
var groq_default = /*#__PURE__*/__webpack_require__.n(groq);
// EXTERNAL MODULE: ./node_modules/next-sanity/dist/next-sanity.esm.js + 2 modules
var next_sanity_esm = __webpack_require__(1035);
;// CONCATENATED MODULE: ./lib/sanity.server.js
/* provided dependency */ var sanity_server_process = __webpack_require__(3454);




// Set up the client for fetching data in the getProps page functions
var sanityClient = (0,next_sanity_esm/* createClient */.eI)(sanity_config/* config */.v);
// Set up a preview client with serverless authentication for drafts
var previewClient = (0,next_sanity_esm/* createClient */.eI)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sanity_config/* config */.v), {
    useCdn: false,
    token: sanity_server_process.env.SANITY_API_TOKEN
}));
// Helper function for easily switching between normal client and preview client
var getClient = function(usePreview) {
    return usePreview ? previewClient : sanityClient;
};

;// CONCATENATED MODULE: ./components/content/view/events/teaser.tsx






var teaser_ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "responsive",
        width: adjustedWidth,
        height: adjustedHeight,
        className: "object-cover object-center w-full transition-all duration-500 lg:h-48 md:h-36 hover:scale-110"
    });
};
function teaser_Figure(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    var adjustedWidth = 615;
    var adjustedHeight = 300;
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(teaser_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
function Teaser(param) {
    var event = param.event;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("article", {
        className: "flex flex-col overflow-hidden rounded-md shadow-md",
        children: [
            (event === null || event === void 0 ? void 0 : event.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "relative flex-shrink-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(teaser_Figure, (0,_object_spread/* default */.Z)({}, event === null || event === void 0 ? void 0 : event.mainImage))
                    }),
                    (event === null || event === void 0 ? void 0 : (ref = event.startDate) === null || ref === void 0 ? void 0 : ref.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalIcon, {
                            startDate: event === null || event === void 0 ? void 0 : (ref1 = event.startDate) === null || ref1 === void 0 ? void 0 : ref1.utc
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "relative flex-shrink-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                            className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                        })
                    }),
                    (event === null || event === void 0 ? void 0 : (ref2 = event.startDate) === null || ref2 === void 0 ? void 0 : ref2.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CalIcon, {
                            startDate: event === null || event === void 0 ? void 0 : (ref3 = event.startDate) === null || ref3 === void 0 ? void 0 : ref3.utc
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex-1",
                    children: [
                        (event === null || event === void 0 ? void 0 : (ref4 = event.category) === null || ref4 === void 0 ? void 0 : ref4.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                url: "/events/category/".concat(event.category.slug),
                                classes: "hover:underline",
                                children: event.category.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "mt-2 mb-1 text-2xl font-semibold text-gray-900",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                href: "/events/".concat(event === null || event === void 0 ? void 0 : event.slug),
                                className: "hover:underline",
                                children: [
                                    "  ",
                                    event.title
                                ]
                            })
                        }),
                        event.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-base text-gray-500",
                            children: event.summary
                        })
                    ]
                })
            })
        ]
    }, event._id);
}

// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(3854);
;// CONCATENATED MODULE: ./components/content/view/events/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '{\n    "events": *[_type == "event" && startDate.utc >= now() ] | order(startDate.utc asc)[0...6]{\n      _id,\n      title,\n      startDate,\n      endDate,\n      category->{_id, title, "slug": slug.current},\n      mainImage,\n      summary,\n      "slug": slug.current,\n    },\n  }'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function UpcomingEvents() {
    var ref = (0,compat_module.useState)([]), events = ref[0], setEvents = ref[1];
    var ref1 = (0,compat_module.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var query = groq_default()(_templateObject());
    (0,compat_module.useEffect)(function() {
        function GetEvents() {
            return _GetEvents.apply(this, arguments);
        }
        function _GetEvents() {
            _GetEvents = (0,_async_to_generator/* default */.Z)(function() {
                var fetchEvents, error, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            fetchEvents = {
                                events: []
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getClient().fetch(query)
                            ];
                        case 2:
                            fetchEvents = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log({
                                error: error
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (fetchEvents) {
                                ;
                                setEvents(fetchEvents === null || fetchEvents === void 0 ? void 0 : (ref = fetchEvents.events) === null || ref === void 0 ? void 0 : ref.slice(0, 3));
                            }
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _GetEvents.apply(this, arguments);
        }
        GetEvents();
    }, [
        query
    ]);
    var EventSkeleton = function() {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("article", {
            className: "flex flex-col overflow-hidden rounded-md shadow-md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "relative flex-shrink-0 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                        className: "bg-slate-300 w-full h-4 pt-[48.78%] w-full relative"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-1/4 h-3 rounded-md bg-slate-300 mb-"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 mb-3 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-1/2 h-6 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            !loading && events && events.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                        gridSize: 3,
                        children: events.map(function(e) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Teaser, {
                                event: e
                            }, e._id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "flex justify-end mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "inline-flex items-center space-x-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/events",
                                    classes: "font-semibold text-gray-600 transition-all cursor-pointer hover:text-gray-800",
                                    children: "View All Events"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiChevronRight */.MOd, {
                                    className: "text-xl"
                                })
                            ]
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(grid/* Grid */.r, {
                gridSize: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {})
                ]
            }),
            !loading && (!events || (events === null || events === void 0 ? void 0 : events.length) < 1) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    children: "Currently there are no latest events."
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/posts/teaser.tsx






var posts_teaser_ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "responsive",
        width: adjustedWidth,
        height: adjustedHeight,
        className: "object-cover object-center w-full transition-all duration-500 lg:h-48 md:h-36 hover:scale-110"
    });
};
function posts_teaser_Figure(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    var adjustedWidth = 615;
    var adjustedHeight = 300;
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(posts_teaser_ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
function teaser_Teaser(param) {
    var post = param.post;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("article", {
        className: "flex flex-col overflow-hidden rounded-md shadow-md",
        children: [
            (post === null || post === void 0 ? void 0 : post.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "relative flex-shrink-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(posts_teaser_Figure, (0,_object_spread/* default */.Z)({}, post.mainImage))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                            dateTime: post.publishedAt.utc,
                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "relative flex-shrink-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                            className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                            dateTime: post.publishedAt.utc,
                            children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex-1",
                    children: [
                        (post === null || post === void 0 ? void 0 : (ref = post.category) === null || ref === void 0 ? void 0 : ref.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                url: "".concat( true ? "/blog" : 0, "/category/").concat(post.category.slug),
                                classes: "hover:underline",
                                children: post.category.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "mt-2 mb-1 text-xl font-semibold text-gray-900",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                href: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                className: "hover:underline",
                                children: [
                                    "  ",
                                    post.title
                                ]
                            })
                        }),
                        post.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-base text-gray-500",
                            children: post.summary
                        })
                    ]
                })
            })
        ]
    }, post._id);
}

;// CONCATENATED MODULE: ./components/content/view/posts/index.tsx



function posts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '{\n    "posts": *[_type == "post" ] | order(publishedAt.utc desc)[0...6]{\n      _id,\n      title,\n      publishedAt,\n      category->{_id, title, "slug": slug.current},\n      mainImage,\n      "slug": slug.current,\n      summary\n    },\n  }'
    ]);
    posts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function LatestPosts() {
    var ref = (0,compat_module.useState)([]), posts = ref[0], setPosts = ref[1];
    var ref1 = (0,compat_module.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var query = groq_default()(posts_templateObject());
    (0,compat_module.useEffect)(function() {
        function GetPosts() {
            return _GetPosts.apply(this, arguments);
        }
        function _GetPosts() {
            _GetPosts = (0,_async_to_generator/* default */.Z)(function() {
                var fetchPosts, error, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            fetchPosts = {
                                posts: []
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getClient().fetch(query)
                            ];
                        case 2:
                            fetchPosts = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log({
                                error: error
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (fetchPosts) {
                                ;
                                setPosts(fetchPosts === null || fetchPosts === void 0 ? void 0 : (ref = fetchPosts.posts) === null || ref === void 0 ? void 0 : ref.slice(0, 3));
                            }
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _GetPosts.apply(this, arguments);
        }
        GetPosts();
    }, [
        query
    ]);
    var EventSkeleton = function() {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("article", {
            className: "flex flex-col overflow-hidden rounded-md shadow-md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "relative flex-shrink-0 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                        className: "bg-slate-300 w-full h-4 pt-[48.78%] relative"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-1/4 h-3 rounded-md bg-slate-300 mb-"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 mb-3 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-1/2 h-6 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            !loading && posts && posts.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                        gridSize: 3,
                        children: posts.map(function(e) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(teaser_Teaser, {
                                post: e
                            }, e._id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "flex justify-end mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "inline-flex items-center space-x-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "".concat( true ? "/blog" : 0),
                                    classes: "font-semibold text-gray-600 transition-all cursor-pointer hover:text-gray-800",
                                    children: "View All Posts"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "text-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiChevronRight */.MOd, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(grid/* Grid */.r, {
                gridSize: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {})
                ]
            }),
            !loading && (!posts || (posts === null || posts === void 0 ? void 0 : posts.length) < 1) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    children: "Currently there are no latest posts."
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/featured-posts/index.tsx



function featured_posts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '{\n    "posts": *[_type == "featuredPosts" ][0]{\n      "featured": featured[]->{\n        _id,\n        title,\n        publishedAt,\n        category->{_id, title, "slug": slug.current},\n        mainImage,\n        "slug": slug.current,\n        summary\n      }\n    },\n  }'
    ]);
    featured_posts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function FeaturedPosts() {
    var ref = (0,compat_module.useState)([]), posts = ref[0], setPosts = ref[1];
    var ref1 = (0,compat_module.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var query = groq_default()(featured_posts_templateObject());
    (0,compat_module.useEffect)(function() {
        function GetPosts() {
            return _GetPosts.apply(this, arguments);
        }
        function _GetPosts() {
            _GetPosts = (0,_async_to_generator/* default */.Z)(function() {
                var fetchPosts, error, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            fetchPosts = {
                                posts: {
                                    featured: []
                                }
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getClient().fetch(query)
                            ];
                        case 2:
                            fetchPosts = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log({
                                error: error
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (fetchPosts) {
                                ;
                                // console.log(fetchPosts)
                                setPosts(fetchPosts === null || fetchPosts === void 0 ? void 0 : (ref = fetchPosts.posts) === null || ref === void 0 ? void 0 : ref.featured);
                            }
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _GetPosts.apply(this, arguments);
        }
        GetPosts();
    }, [
        query
    ]);
    var EventSkeleton = function() {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("article", {
            className: "flex flex-col overflow-hidden rounded-md shadow-md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "relative flex-shrink-0 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                        className: "bg-slate-300 w-full h-4 pt-[48.78%] relative"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-1/4 h-3 rounded-md bg-slate-300 mb-"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 mb-3 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-1/2 h-6 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mb-2 animate-pulse",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "w-full h-3 rounded-md bg-slate-300"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            !loading && posts && posts.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                        gridSize: 3,
                        children: posts.map(function(e) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(teaser_Teaser, {
                                post: e
                            }, e._id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "flex justify-end mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "inline-flex items-center space-x-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/news",
                                    classes: "font-semibold text-gray-600 transition-all cursor-pointer hover:text-gray-800",
                                    children: "View All News"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "text-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiChevronRight */.MOd, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(grid/* Grid */.r, {
                gridSize: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventSkeleton, {})
                ]
            }),
            !loading && (!posts || (posts === null || posts === void 0 ? void 0 : posts.length) < 1) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                    children: "Currently there are no featured news."
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/view/index.tsx









ViewComponent.propTypes = {
    contentView: (prop_types_default()).string.isRequired,
    webform: (prop_types_default()).object,
    view: (prop_types_default()).object,
    filter: (prop_types_default()).string,
    centerAlign: (prop_types_default()).bool
};
function ViewComponent(props) {
    var contentView = props.contentView, webform = props.webform, view = props.view, filter = props.filter, centerAlign = props.centerAlign;
    if (centerAlign) {
        if (contentView === "componentViewContact") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Contact, {
                        webform: webform
                    })
                })
            });
        } else if (contentView === "componentViewJobApp") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(JobApp, {
                        webform: webform
                    })
                })
            });
        } else if (contentView === "componentViewPosts" || contentView === "componentViewEvents") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ContentView, {
                        view: view
                    })
                })
            });
        } else if (contentView === "componentViewTeam") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TeamView, {
                        view: view
                    })
                })
            });
        } else if (contentView === "componentViewLatestPosts") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LatestPosts, {})
                })
            });
        } else if (contentView === "componentViewUpcomingEvents") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(UpcomingEvents, {})
                })
            });
        } else if (contentView === "componentMCSubForm") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16"
                })
            });
        } else if (contentView === "componentViewFeaturedPosts") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FeaturedPosts, {})
                })
            });
        } else {
            return null;
        }
    } else {
        if (contentView === "componentViewContact") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Contact, {
                    webform: webform
                })
            });
        } else if (contentView === "componentViewJobApp") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(JobApp, {
                    webform: webform
                })
            });
        } else if (contentView === "componentViewPosts" || contentView === "componentViewEvents") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ContentView, {
                    view: view
                })
            });
        } else if (contentView === "componentViewTeam") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TeamView, {
                    view: view
                })
            });
        } else if (contentView === "componentViewLatestPosts") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LatestPosts, {})
            });
        } else if (contentView === "componentViewUpcomingEvents") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(UpcomingEvents, {})
            });
        } else if (contentView === "componentMCSubForm") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper"
            });
        } else if (contentView === "componentViewFeaturedPosts") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FeaturedPosts, {})
            });
        } else {
            return null;
        }
    }
}

// EXTERNAL MODULE: ./components/content/super-image/index.js
var super_image = __webpack_require__(5621);
;// CONCATENATED MODULE: ./components/content/image/index.tsx


function image_ImageComponent(param) {
    var content = param.content;
    // console.log({content})
    var image = content.image, width = content.width, height = content.height, alignment = content.alignment, alt = content.alt;
    var centerAlign = (content || false).centerAlign;
    var fullWidth = (content || false).fullWidth;
    var imgAlignment = function(val) {
        if (val === "left") {
            return "text-left";
        } else if (val === "right") {
            return "text-right";
        } else {
            return "text-center";
        }
    };
    if (fullWidth) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
            className: "full-width mb-8 md:mb-12 lg:mb-16 ",
            style: {
                height: height + "px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(super_image/* SuperImage */.K, {
                image: image,
                imageAltText: alt || "Image",
                adjustedHeight: height,
                adjustedWidth: width,
                fullWidth: fullWidth,
                classes: "",
                priority: false
            })
        });
    } else {
        // Scaled Images
        if (centerAlign) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                    className: "mb-8 md:mb-12 lg:mb-16 ".concat(imgAlignment(content === null || content === void 0 ? void 0 : content.alignment)),
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(super_image/* SuperImage */.K, {
                        image: image,
                        imageAltText: alt || "Image",
                        adjustedHeight: height,
                        adjustedWidth: width,
                        fullWidth: fullWidth,
                        classes: "",
                        priority: false
                    })
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                className: "inner-wrapper mb-8 md:mb-12 lg:mb-16 ".concat(imgAlignment(content === null || content === void 0 ? void 0 : content.alignment)),
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(super_image/* SuperImage */.K, {
                    image: image,
                    imageAltText: alt || "Image",
                    adjustedHeight: height,
                    adjustedWidth: width,
                    fullWidth: fullWidth,
                    classes: "",
                    priority: false
                })
            });
        }
    }
}

// EXTERNAL MODULE: ./node_modules/react-instagram-embed/es/index.js
var es = __webpack_require__(5064);
;// CONCATENATED MODULE: ./components/content/instagram-post/index.js


function InstagramPost(param) {
    var url = param.url;
    if (!url) {
        return null;
    } else if (false) {} else if (url.includes("https") || url.includes("http")) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
            className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(es/* default */.Z, {
                url: url,
                clientAccessToken: "".concat("670737054366968", "|").concat("97a825c8dc2ae70ff05531b878146ce7"),
                maxWidth: 320,
                hideCaption: false,
                containerTagName: "div",
                protocol: "",
                injectScript: true,
                onLoading: function() {},
                onSuccess: function() {},
                onAfterRender: function() {},
                onFailure: function() {}
            })
        });
    } else {
        return null;
    }
}

// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 35 modules
var esm = __webpack_require__(2117);
// EXTERNAL MODULE: ./node_modules/get-video-id/dist/get-video-id.esm.js
var get_video_id_esm = __webpack_require__(4329);
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/index.es.jsx
var index_es = __webpack_require__(640);
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css
var LiteYouTubeEmbed = __webpack_require__(3879);
;// CONCATENATED MODULE: ./components/content/youtube/index.tsx






function YouTubeVideo(param) {
    var url = param.url, maxWidth = param.maxWidth, centerAlign = param.centerAlign;
    var ref = (0,compat_module.useRef)(null);
    var entry = (0,esm/* useIntersectionObserver */.S1)(ref, {
        root: null,
        // rootMargin: "0px 0px -100%",
        rootMargin: "100%",
        threshold: 0
    });
    var isVisible = !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    var id = (0,get_video_id_esm/* default */.Z)(url).id;
    if (!url || !id) {
        return null;
    } else if (url.includes("https") || url.includes("http")) {
        if (centerAlign) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        style: {
                            marginLeft: "auto",
                            marginRight: "auto",
                            maxWidth: maxWidth ? "".concat(maxWidth, "px") : "100%"
                        },
                        ref: ref,
                        children: isVisible && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                            title: "YouTube Video",
                            id: id,
                            adNetwork: false,
                            noCookie: true
                        })
                    })
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    style: {
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxWidth: maxWidth ? "".concat(maxWidth, "px") : "100%"
                    },
                    ref: ref,
                    children: isVisible && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                        title: "YouTube Video",
                        id: id,
                        adNetwork: false,
                        noCookie: true
                    })
                })
            });
        }
    } else {
        return null;
    }
}

;// CONCATENATED MODULE: ./components/content/vimeo/index.tsx




function VimeoVideo(param) {
    var url = param.url, maxWidth = param.maxWidth, centerAlign = param.centerAlign;
    var ref = (0,compat_module.useRef)(null);
    var entry = (0,esm/* useIntersectionObserver */.S1)(ref, {});
    var isVisible = !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    var id = (0,get_video_id_esm/* default */.Z)(url).id;
    var embedURL = "https://player.vimeo.com/video/".concat(id);
    if (!url || !id || !embedURL) {
        return null;
    } else if (url.includes("https") || url.includes("http")) {
        if (centerAlign) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                ref: ref,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "mx-auto",
                        style: {
                            maxWidth: maxWidth ? "".concat(maxWidth, "px") : "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "aspect-w-16 aspect-h-9",
                            children: isVisible && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("iframe", {
                                src: embedURL,
                                frameBorder: "0",
                                title: "Video",
                                allowFullScreen: true
                            })
                        })
                    })
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                ref: ref,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "mx-auto",
                    style: {
                        maxWidth: maxWidth ? "".concat(maxWidth, "px") : "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "aspect-w-16 aspect-h-9",
                        children: isVisible && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("iframe", {
                            src: embedURL,
                            frameBorder: "0",
                            title: "Video",
                            allowFullScreen: true
                        })
                    })
                })
            });
        }
    } else {
        return null;
    }
}

// EXTERNAL MODULE: ./components/layout/content-components/serializers/iFrame.js
var iFrame = __webpack_require__(3243);
// EXTERNAL MODULE: ./components/layout/content-components/serializers/pdf.js
var pdf = __webpack_require__(121);
;// CONCATENATED MODULE: ./components/content/optionsTable/optionItem.tsx






OptionItem.propTypes = {
    layout: (prop_types_default()).string,
    optionListTitle: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    icon: (prop_types_default()).any,
    pricePerMonth: (prop_types_default()).number,
    pricePerYear: (prop_types_default()).number,
    callToAction: (prop_types_default()).any,
    optionItemText: (prop_types_default()).any,
    centerAlign: ((prop_types_default()) === null || (prop_types_default()) === void 0 ? void 0 : (prop_types_default()).bool) || false
};
function TopMargin(type) {
    if (type === "buttonIcon" || type === "button") {
        return "mt-4";
    } else {
        return "mt-3";
    }
}
function OptionItem(props) {
    var layout = props.layout, title = props.title, text = props.text, icon = props.icon, pricePerYear = props.pricePerYear, pricePerMonth = props.pricePerMonth, callToAction = props.callToAction, optionItemText = props.optionItemText, optionListTitle = props.optionListTitle, centerAlign = props.centerAlign;
    if (layout === "columns") {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "flex flex-col bg-white rounded-lg shadow-xl ring-1 ring-black/10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "p-6 sm:p-7",
                    children: [
                        title ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "text-2xl font-semibold text-gray-900",
                            children: title
                        }) : null,
                        pricePerMonth && pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-center mt-3 space-x-3",
                            children: [
                                pricePerMonth ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-4xl font-bold tracking-tight text-brand-2-600",
                                    children: [
                                        "$",
                                        pricePerMonth
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    children: [
                                        pricePerMonth ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "per month"
                                        }) : null,
                                        pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-sm text-gray-500",
                                            children: [
                                                "Billed yearly ($",
                                                pricePerYear,
                                                ")"
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        pricePerMonth && !pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-baseline mt-3 space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-4xl font-bold tracking-tight text-brand-2-600",
                                    children: [
                                        "$",
                                        pricePerMonth
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "per month"
                                })
                            ]
                        }) : null,
                        !pricePerMonth && pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-baseline mt-3 space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-4xl font-bold tracking-tight text-brand-2-600",
                                    children: [
                                        "$",
                                        pricePerYear
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "per year"
                                })
                            ]
                        }) : null,
                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-6 prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-prose",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                blocks: text
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex flex-col flex-1 p-2",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex flex-col justify-between flex-1 p-6 rounded-lg bg-gray-50 sm:p-7",
                        children: [
                            optionListTitle ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                className: "mb-4 text-sm font-medium text-gray-900",
                                children: optionListTitle
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                role: "list",
                                className: "mt-4 mb-4 space-y-3",
                                children: optionItemText ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                    children: optionItemText.map(function(text) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "flex items-start",
                                            children: [
                                                (icon === null || icon === void 0 ? void 0 : icon.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                    className: "inline-flex items-center justify-center text-brand-2-500",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                                                        name: (0,helpers/* transformToUpperCase */.n8)(icon === null || icon === void 0 ? void 0 : icon.name, [
                                                            "-"
                                                        ]),
                                                        size: "2em",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                    className: "ml-3 text-gray-500 prose-a:underline hover:prose-a:no-underline",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                        blocks: text === null || text === void 0 ? void 0 : text.title
                                                    })
                                                })
                                            ]
                                        }, text === null || text === void 0 ? void 0 : text._key);
                                    })
                                }) : null
                            }),
                            callToAction && (callToAction === null || callToAction === void 0 ? void 0 : callToAction.type) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "".concat(TopMargin(callToAction === null || callToAction === void 0 ? void 0 : callToAction.type)),
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title,
                                        url: callToAction === null || callToAction === void 0 ? void 0 : callToAction.url,
                                        type: callToAction === null || callToAction === void 0 ? void 0 : callToAction.type,
                                        icon: callToAction === null || callToAction === void 0 ? void 0 : (ref = callToAction.icon) === null || ref === void 0 ? void 0 : ref.name,
                                        style: "primary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: true
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        });
    } else if (layout === "simple-columns") {
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "relative flex flex-col p-8 bg-white border border-gray-200 rounded-lg shadow-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex-1",
                    children: [
                        title ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "text-2xl font-semibold text-gray-900",
                            children: title
                        }) : null,
                        pricePerMonth && pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-center mt-3 space-x-3",
                            children: [
                                pricePerMonth ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-5xl font-bold tracking-tight",
                                    children: [
                                        "$",
                                        pricePerMonth
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    children: [
                                        pricePerMonth ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "per month"
                                        }) : null,
                                        pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-sm text-gray-500",
                                            children: [
                                                "Billed yearly ($",
                                                pricePerYear,
                                                ")"
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        pricePerMonth && !pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-baseline mt-3 space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-5xl font-bold tracking-tight",
                                    children: [
                                        "$",
                                        pricePerMonth
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "per month"
                                })
                            ]
                        }) : null,
                        !pricePerMonth && pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-baseline mt-3 space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-5xl font-bold tracking-tight",
                                    children: [
                                        "$",
                                        pricePerYear
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "per year"
                                })
                            ]
                        }) : null,
                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-6 prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-prose",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                blocks: text
                            })
                        }),
                        optionListTitle ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "mt-8 text-sm font-medium text-gray-900",
                            children: optionListTitle
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                            role: "list",
                            className: "mt-4 mb-4 space-y-3",
                            children: optionItemText ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: optionItemText.map(function(text) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("li", {
                                        className: "flex items-start",
                                        children: [
                                            (icon === null || icon === void 0 ? void 0 : icon.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                className: "inline-flex items-center justify-center text-brand-2-500",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                                                    name: (0,helpers/* transformToUpperCase */.n8)(icon === null || icon === void 0 ? void 0 : icon.name, [
                                                        "-"
                                                    ]),
                                                    size: "2em",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                className: "ml-3 text-gray-500",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                    blocks: text === null || text === void 0 ? void 0 : text.title
                                                })
                                            })
                                        ]
                                    }, text === null || text === void 0 ? void 0 : text._key);
                                })
                            }) : null
                        })
                    ]
                }),
                callToAction && (callToAction === null || callToAction === void 0 ? void 0 : callToAction.type) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "mt-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "".concat(TopMargin(callToAction === null || callToAction === void 0 ? void 0 : callToAction.type)),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                            title: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title,
                            url: callToAction === null || callToAction === void 0 ? void 0 : callToAction.url,
                            type: callToAction === null || callToAction === void 0 ? void 0 : callToAction.type,
                            icon: callToAction === null || callToAction === void 0 ? void 0 : (ref1 = callToAction.icon) === null || ref1 === void 0 ? void 0 : ref1.name,
                            style: "primary",
                            size: "lg",
                            theme: "light",
                            fullWidth: true
                        })
                    })
                })
            ]
        });
    } else if (layout === "stacked") {
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: " ".concat(centerAlign ? "pb-8 md:pb-12 space-y-6" : "pb-8 md:pb-12 xl:grid xl:grid-cols-3 xl:gap-x-8", " "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    children: [
                        title ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "text-2xl font-semibold text-gray-900",
                            children: title
                        }) : null,
                        pricePerMonth && pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-center mt-3 space-x-3",
                            children: [
                                pricePerMonth ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-4xl font-bold tracking-tight text-brand-2-600",
                                    children: [
                                        "$",
                                        pricePerMonth
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    children: [
                                        pricePerMonth ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "text-sm text-gray-700",
                                            children: "per month"
                                        }) : null,
                                        pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-sm text-gray-500",
                                            children: [
                                                "Billed yearly ($",
                                                pricePerYear,
                                                ")"
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        pricePerMonth && !pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-baseline mt-3 space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-4xl font-bold tracking-tight text-brand-2-600",
                                    children: [
                                        "$",
                                        pricePerMonth
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "per month"
                                })
                            ]
                        }) : null,
                        !pricePerMonth && pricePerYear ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-baseline mt-3 space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-4xl font-bold tracking-tight text-brand-2-600",
                                    children: [
                                        "$",
                                        pricePerYear
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-sm text-gray-700",
                                    children: "per year"
                                })
                            ]
                        }) : null,
                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-6 prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-prose",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                blocks: text
                            })
                        }),
                        callToAction && (callToAction === null || callToAction === void 0 ? void 0 : callToAction.type) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "".concat(TopMargin(callToAction === null || callToAction === void 0 ? void 0 : callToAction.type)),
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title,
                                    url: callToAction === null || callToAction === void 0 ? void 0 : callToAction.url,
                                    type: callToAction === null || callToAction === void 0 ? void 0 : callToAction.type,
                                    icon: callToAction === null || callToAction === void 0 ? void 0 : (ref2 = callToAction.icon) === null || ref2 === void 0 ? void 0 : ref2.name,
                                    style: "primary",
                                    size: "lg",
                                    theme: "light",
                                    fullWidth: false
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "col-span-2 mt-6 md:mt-2",
                    children: [
                        optionListTitle ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex items-center mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h4", {
                                    className: "flex-shrink-0 pr-4 text-base font-semibold bg-white text-brand-2-700",
                                    children: optionListTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "flex-1 border-t-2 border-gray-200"
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                            role: "list",
                            className: "".concat(centerAlign ? "space-y-2" : "md:grid md:grid-cols-2 gap-x-6 gap-y-4"),
                            children: optionItemText ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: optionItemText.map(function(text) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("li", {
                                        className: "flex items-start",
                                        children: [
                                            (icon === null || icon === void 0 ? void 0 : icon.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                className: "inline-flex items-center justify-center text-brand-2-500",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((react_icons_wrapper_default()), {
                                                    name: (0,helpers/* transformToUpperCase */.n8)(icon === null || icon === void 0 ? void 0 : icon.name, [
                                                        "-"
                                                    ]),
                                                    size: "2em",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                className: "ml-3 text-gray-500",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                    blocks: text === null || text === void 0 ? void 0 : text.title
                                                })
                                            })
                                        ]
                                    }, text === null || text === void 0 ? void 0 : text._key);
                                })
                            }) : null
                        })
                    ]
                })
            ]
        });
    } else {
        return null;
    }
}

;// CONCATENATED MODULE: ./components/content/optionsTable/index.tsx



// import Link from 'next/link';
// import Image from 'next/image';

// import { Linker } from '@/components/content/linker'



OptionsTable.propTypes = {
    layout: (prop_types_default()).string,
    tagline: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    icon: (prop_types_default()).any,
    optionLayout: (prop_types_default()).string,
    optionListTitle: (prop_types_default()).string,
    optionItems: (prop_types_default()).array,
    centerAlign: ((prop_types_default()) === null || (prop_types_default()) === void 0 ? void 0 : (prop_types_default()).bool) || false
};
function OptionsTable(props) {
    var layout = props.layout, title = props.title, tagline = props.tagline, text = props.text, icon = props.icon, optionLayout = props.optionLayout, optionListTitle = props.optionListTitle, optionItems = props.optionItems, centerAlign = props.centerAlign;
    if (centerAlign) {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                text: tagline,
                                size: "md",
                                theme: "light",
                                classes: "text-center"
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                className: "prose text-center md:prose-lg lg:prose-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                    children: title
                                })
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            optionItems && (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12 md:mt-4",
                                children: optionLayout === "stacked" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                            centerAlign: centerAlign,
                                            layout: optionLayout ? optionLayout : null,
                                            optionListTitle: optionListTitle ? optionListTitle : null,
                                            title: option === null || option === void 0 ? void 0 : option.title,
                                            icon: icon ? icon : null,
                                            pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                            pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                            text: option === null || option === void 0 ? void 0 : option.text,
                                            callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                            optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                        }, option._key);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) >= 4 ? 2 : optionItems === null || optionItems === void 0 ? void 0 : optionItems.length,
                                    children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                            centerAlign: centerAlign,
                                            layout: optionLayout,
                                            optionListTitle: optionListTitle,
                                            title: option === null || option === void 0 ? void 0 : option.title,
                                            icon: icon,
                                            pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                            pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                            text: option === null || option === void 0 ? void 0 : option.text,
                                            callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                            optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                        }, option._key);
                                    })
                                })
                            }) : null
                        ]
                    })
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: [
                        tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                            text: tagline,
                            size: "md",
                            theme: "light",
                            classes: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative bg-white md:grid md:grid-cols-12 md:gap-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "max-w-2xl md:col-span-6 md:text-left ",
                                    children: [
                                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "prose md:prose-lg lg:prose-xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                                className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                                children: title
                                            })
                                        }),
                                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "prose prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                blocks: text
                                            })
                                        })
                                    ]
                                }),
                                optionItems && (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mt-12 md:col-span-6 md:mt-4",
                                    children: optionLayout === "stacked" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                                centerAlign: centerAlign,
                                                layout: optionLayout ? optionLayout : null,
                                                optionListTitle: optionListTitle ? optionListTitle : null,
                                                title: option === null || option === void 0 ? void 0 : option.title,
                                                icon: icon ? icon : null,
                                                pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                                pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                                text: option === null || option === void 0 ? void 0 : option.text,
                                                callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                                optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                            }, option._key);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                        gridSize: optionItems === null || optionItems === void 0 ? void 0 : optionItems.length,
                                        children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                                centerAlign: centerAlign,
                                                layout: optionLayout,
                                                optionListTitle: optionListTitle,
                                                title: option === null || option === void 0 ? void 0 : option.title,
                                                icon: icon,
                                                pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                                pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                                text: option === null || option === void 0 ? void 0 : option.text,
                                                callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                                optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                            }, option._key);
                                        })
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                text: tagline,
                                size: "md",
                                theme: "light",
                                classes: ""
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                className: "prose text-center md:prose-lg lg:prose-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                    children: title
                                })
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            optionItems && (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: optionLayout === "stacked" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "pt-6 md:pt-8",
                                    children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                            centerAlign: centerAlign,
                                            layout: optionLayout ? optionLayout : null,
                                            optionListTitle: optionListTitle ? optionListTitle : null,
                                            title: option === null || option === void 0 ? void 0 : option.title,
                                            icon: icon ? icon : null,
                                            pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                            pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                            text: option === null || option === void 0 ? void 0 : option.text,
                                            callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                            optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                        }, option._key);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mt-12 md:mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                        gridSize: (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) >= 4 ? 2 : optionItems === null || optionItems === void 0 ? void 0 : optionItems.length,
                                        children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                                layout: optionLayout ? optionLayout : null,
                                                optionListTitle: optionListTitle ? optionListTitle : null,
                                                title: option === null || option === void 0 ? void 0 : option.title,
                                                icon: icon ? icon : null,
                                                pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                                pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                                text: option === null || option === void 0 ? void 0 : option.text,
                                                callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                                optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText,
                                                centerAlign: centerAlign
                                            }, option._key);
                                        })
                                    })
                                })
                            }) : null
                        ]
                    })
                })
            });
        }
    } else {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md mx-auto text-center sm:max-w-3xl md:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose text-center md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        optionItems && (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-12 md:mt-4",
                            children: optionLayout === "stacked" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                        centerAlign: centerAlign,
                                        layout: optionLayout ? optionLayout : null,
                                        optionListTitle: optionListTitle ? optionListTitle : null,
                                        title: option === null || option === void 0 ? void 0 : option.title,
                                        icon: icon ? icon : null,
                                        pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                        pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                        text: option === null || option === void 0 ? void 0 : option.text,
                                        callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                        optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                    }, option._key);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                gridSize: optionItems === null || optionItems === void 0 ? void 0 : optionItems.length,
                                children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                        centerAlign: centerAlign,
                                        layout: optionLayout,
                                        optionListTitle: optionListTitle,
                                        title: option === null || option === void 0 ? void 0 : option.title,
                                        icon: icon,
                                        pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                        pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                        text: option === null || option === void 0 ? void 0 : option.text,
                                        callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                        optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                    }, option._key);
                                })
                            })
                        }) : null
                    ]
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: [
                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                        text: tagline,
                        size: "md",
                        theme: "light",
                        classes: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white md:grid md:grid-cols-12 md:gap-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-2xl md:col-span-4 md:text-left ",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            optionItems && (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12 md:col-span-8 md:mt-4",
                                children: optionLayout === "stacked" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                            centerAlign: centerAlign,
                                            layout: optionLayout ? optionLayout : null,
                                            optionListTitle: optionListTitle ? optionListTitle : null,
                                            title: option === null || option === void 0 ? void 0 : option.title,
                                            icon: icon ? icon : null,
                                            pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                            pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                            text: option === null || option === void 0 ? void 0 : option.text,
                                            callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                            optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                        }, option._key);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: optionItems === null || optionItems === void 0 ? void 0 : optionItems.length,
                                    children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                            centerAlign: centerAlign,
                                            layout: optionLayout,
                                            optionListTitle: optionListTitle,
                                            title: option === null || option === void 0 ? void 0 : option.title,
                                            icon: icon,
                                            pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                            pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                            text: option === null || option === void 0 ? void 0 : option.text,
                                            callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                            optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                        }, option._key);
                                    })
                                })
                            }) : null
                        ]
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        optionItems && (optionItems === null || optionItems === void 0 ? void 0 : optionItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                            children: optionLayout === "stacked" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "pt-6 md:pt-8",
                                children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                        centerAlign: centerAlign,
                                        layout: optionLayout ? optionLayout : null,
                                        optionListTitle: optionListTitle ? optionListTitle : null,
                                        title: option === null || option === void 0 ? void 0 : option.title,
                                        icon: icon ? icon : null,
                                        pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                        pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                        text: option === null || option === void 0 ? void 0 : option.text,
                                        callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                        optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText
                                    }, option._key);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12 md:mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                                    gridSize: optionItems === null || optionItems === void 0 ? void 0 : optionItems.length,
                                    children: optionItems === null || optionItems === void 0 ? void 0 : optionItems.map(function(option) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(OptionItem, {
                                            layout: optionLayout ? optionLayout : null,
                                            optionListTitle: optionListTitle ? optionListTitle : null,
                                            title: option === null || option === void 0 ? void 0 : option.title,
                                            icon: icon ? icon : null,
                                            pricePerMonth: option === null || option === void 0 ? void 0 : option.pricePerMonth,
                                            pricePerYear: option === null || option === void 0 ? void 0 : option.pricePerYear,
                                            text: option === null || option === void 0 ? void 0 : option.text,
                                            callToAction: option === null || option === void 0 ? void 0 : option.callToAction,
                                            optionItemText: option === null || option === void 0 ? void 0 : option.optionItemText,
                                            centerAlign: centerAlign
                                        }, option._key);
                                    })
                                })
                            })
                        }) : null
                    ]
                })
            });
        }
    }
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(3342);
;// CONCATENATED MODULE: ./components/content/faq/faqItem.tsx





function FaqItem(param) {
    var title = param.title, text = param.text;
    var ref = (0,compat_module.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "pt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dt", {
                className: "text-lg font-medium leading-6 text-gray-900",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                    type: "button",
                    className: "flex items-start justify-between w-full text-left text-gray-400",
                    onClick: function() {
                        return setOpen(!open);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "font-medium text-gray-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "flex items-center ml-6 h-7",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ChevronDownIcon/* default */.Z, {
                                className: (0,helpers/* classNames */.AK)(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform"),
                                "aria-hidden": "true"
                            })
                        })
                    ]
                })
            }),
            open ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dd", {
                className: "mt-2 text-base text-gray-500",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                    blocks: text
                })
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dd", {})
        ]
    });
}

;// CONCATENATED MODULE: ./components/content/faq/faqItems.tsx




FAQItems.propTypes = {
    layout: (prop_types_default()).string,
    faqs: (prop_types_default()).array
};
function faqItems_TopMargin(type) {
    if (type === "buttonIcon" || type === "button") {
        return "mt-4";
    } else {
        return "mt-3";
    }
}
function FAQItems(props) {
    var faqs = props.faqs, layout = props.layout;
    if (layout === "accordion") {
        // return null
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dl", {
            className: "space-y-6 divide-y divide-gray-200",
            children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq) {
                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(FaqItem, {
                    title: faq === null || faq === void 0 ? void 0 : faq.title,
                    text: faq === null || faq === void 0 ? void 0 : faq.text
                }, faq._key);
            })
        });
    } else if (layout === "simple-stacked") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dl", {
            className: "space-y-12",
            children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq) {
                /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dt", {
                            className: "text-lg font-medium leading-6 text-gray-900",
                            children: faq === null || faq === void 0 ? void 0 : faq.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("dd", {
                            className: "mt-2 text-base text-gray-500",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                blocks: faq === null || faq === void 0 ? void 0 : faq.text
                            })
                        })
                    ]
                }, faq.question);
            })
        });
    }
}

;// CONCATENATED MODULE: ./components/content/faq/index.tsx






// import { OptionItem } from '../optionsTable/optionItem';
FAQSection.propTypes = {
    layout: (prop_types_default()).string,
    tagline: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: (prop_types_default()).array,
    faqsLayout: (prop_types_default()).string,
    faqs: (prop_types_default()).array,
    centerAlign: (prop_types_default()).bool
};
function FAQSection(props) {
    var layout = props.layout, title = props.title, tagline = props.tagline, text = props.text, faqsLayout = props.faqsLayout, faqs = props.faqs, centerAlign = props.centerAlign;
    if (centerAlign) {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                text: tagline,
                                size: "md",
                                theme: "light",
                                classes: " text-center"
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                className: "prose text-center md:prose-lg lg:prose-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                    children: title
                                })
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            faqs && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQItems, {
                                faqs: faqs,
                                layout: faqsLayout
                            })
                        ]
                    })
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: [
                        tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                            text: tagline,
                            size: "md",
                            theme: "light",
                            classes: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "relative bg-white md:grid md:grid-cols-12 md:gap-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "max-w-2xl md:col-span-5 md:text-left",
                                    children: [
                                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "prose md:prose-lg lg:prose-xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                                className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                                children: title
                                            })
                                        }),
                                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "text-xl prose prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                blocks: text
                                            })
                                        })
                                    ]
                                }),
                                faqs && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mt-12 md:mt-0 md:col-span-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQItems, {
                                        faqs: faqs,
                                        layout: faqsLayout
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                                children: [
                                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                        text: tagline,
                                        size: "md",
                                        theme: "light",
                                        classes: ""
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "text-xl prose prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline md:prose-lg lg:prose-xl max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            faqs && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQItems, {
                                faqs: faqs,
                                layout: faqsLayout
                            })
                        ]
                    })
                })
            });
        }
    } else {
        if (layout === "centered") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md mx-auto text-center sm:max-w-3xl md:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mx-auto text-xl prose text-left prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        faqs && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQItems, {
                            faqs: faqs,
                            layout: faqsLayout
                        })
                    ]
                })
            });
        } else if (layout === "side-by-side") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: [
                    tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                        text: tagline,
                        size: "md",
                        theme: "light",
                        classes: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "relative bg-white md:grid md:grid-cols-12 md:gap-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "max-w-2xl md:col-span-4 md:text-left ",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                            children: title
                                        })
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "text-xl prose prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-prose md:prose-lg lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            faqs && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-12 md:mt-0 md:col-span-8",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQItems, {
                                    faqs: faqs,
                                    layout: faqsLayout
                                })
                            })
                        ]
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "relative bg-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "max-w-md text-left sm:max-w-3xl lg:max-w-7xl",
                            children: [
                                tagline && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_tagline/* Tagline */.B, {
                                    text: tagline,
                                    size: "md",
                                    theme: "light",
                                    classes: ""
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "font-extrabold tracking-tight text-gray-900 !mt-1 !mb-3",
                                        children: title
                                    })
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "text-xl prose prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-prose md:prose-lg lg:prose-xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        faqs && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQItems, {
                            faqs: faqs,
                            layout: faqsLayout
                        })
                    ]
                })
            });
        }
    }
}

;// CONCATENATED MODULE: ./components/content/cta/index.tsx




CTASection.propTypes = {
    layout: (prop_types_default()).string,
    centerAlign: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    subTitle: (prop_types_default()).string,
    text: (prop_types_default()).array,
    callToActionPrimary: (prop_types_default()).object,
    callToActionSecondary: (prop_types_default()).object
};
function CTASection(props) {
    var layout = props.layout, centerAlign = props.centerAlign, title = props.title, subTitle = props.subTitle, text = props.text, callToActionPrimary = props.callToActionPrimary, callToActionSecondary = props.callToActionSecondary;
    if (centerAlign) {
        // Narrow Layout -----
        if (layout === "centered") {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "mx-auto prose text-center max-w-7xl md:prose-lg lg:prose-xl",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "tracking-tight text-gray-900 !mb-0",
                            children: title
                        }),
                        subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "tracking-tight text-brand-2-700 !mb-0",
                            children: subTitle
                        }),
                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 max-w-none",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                blocks: text
                            })
                        }),
                        (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col items-center justify-center gap-4 mt-8 text-center sm:flex-row md:gap-6 md:flex-none not-prose",
                            children: [
                                callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionPrimary.title,
                                    url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                    type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                    icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : (ref = callToActionPrimary.icon) === null || ref === void 0 ? void 0 : ref.name,
                                    style: "primary",
                                    size: "lg",
                                    theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                    fullWidth: false
                                }),
                                callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                    url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                    type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                    icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : (ref1 = callToActionSecondary.icon) === null || ref1 === void 0 ? void 0 : ref1.name,
                                    style: "secondary",
                                    size: "lg",
                                    theme: "light",
                                    fullWidth: false
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (layout === "centered-branded") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "rounded-md bg-slate-100",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "max-w-3xl px-4 pt-6 pb-8 mx-auto prose text-center lg:pt-10 lg:pb-12 md:prose-lg lg:prose-xl",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                className: "tracking-tight text-gray-900 !mb-0",
                                children: title
                            }),
                            subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                className: "tracking-tight text-brand-2-700 !mb-0",
                                children: subTitle
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline max-w-none prose-p:!mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col items-center justify-center gap-4 mt-8 text-center sm:flex-row md:gap-6 md:flex-none not-prose",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "centered-branded-full") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 bg-slate-100 md:mb-12 lg:mb-16 ",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "px-4 md:px-0 inner-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "max-w-3xl pt-6 pb-8 mx-auto prose text-center lg:pt-10 lg:pb-12 md:prose-lg lg:prose-xl",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                className: "tracking-tight text-gray-900 !mb-0",
                                children: title
                            }),
                            subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                className: "tracking-tight text-brand-2-700 !mb-0",
                                children: subTitle
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 max-w-none",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col items-center justify-center gap-4 mt-8 text-center sm:flex-row md:gap-6 md:flex-none not-prose",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "justified") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full px-3 lg:mx-auto lg:max-w-4xl lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "max-w-4xl mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "gap-4 pb-8 mx-auto lg:pb-12 lg:flex lg:items-center lg:justify-between md:gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 prose-p:last-of-type:mb-0 max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 lg:mt-0 md:gap-6 md:flex-none md:text-right",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "justified-branded") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "rounded-md bg-slate-100",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "max-w-4xl mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "gap-4 pt-6 pb-8 mx-auto lg:pt-10 lg:pb-12 lg:flex lg:items-center lg:justify-between md:gap-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                    children: [
                                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                            className: "tracking-tight text-gray-900 !mb-0",
                                            children: title
                                        }),
                                        subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "tracking-tight text-brand-2-700 !mb-0",
                                            children: subTitle
                                        }),
                                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 prose-p:last-of-type:mb-0 max-w-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                                blocks: text
                                            })
                                        })
                                    ]
                                }),
                                (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "flex flex-col gap-4 mt-8 lg:mt-0 md:gap-6 md:flex-none md:text-right",
                                    children: [
                                        callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                            title: callToActionPrimary.title,
                                            url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                            type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                            icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                            style: "primary",
                                            size: "lg",
                                            theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                            fullWidth: false
                                        }),
                                        callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                            title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                            url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                            type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                            icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                            style: "secondary",
                                            size: "lg",
                                            theme: "light",
                                            fullWidth: false
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            });
        } else if (layout === "justified-branded-full") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 bg-slate-100 md:mb-12 lg:mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "w-full max-w-4xl mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "gap-4 px-4 pt-6 pb-8 lg:px-0 lg:pt-10 lg:pb-12 lg:flex lg:items-center lg:justify-between md:gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 prose-p:last-of-type:mb-0 max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 lg:mt-0 md:gap-6 md:flex-none md:text-right",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "stacked") {
            return(//  mb-8 md:mb-12 lg:mb-16
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "pb-8 mx-auto rounded-md lg:flex lg:flex-col lg:pb-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col prose md:prose-lg lg:prose-xl",
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "tracking-tight text-gray-900 !mb-0",
                                    children: title
                                }),
                                subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "tracking-tight text-brand-2-700 !mb-0",
                                    children: subTitle
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 prose-p:last-of-type:mb-0 max-w-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                            children: [
                                callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionPrimary.title,
                                    url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                    type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                    icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                    style: "primary",
                                    size: "lg",
                                    theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                    fullWidth: false
                                }),
                                callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                    url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                    type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                    icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                    style: "secondary",
                                    size: "lg",
                                    theme: "light",
                                    fullWidth: false
                                })
                            ]
                        })
                    ]
                })
            }));
        } else if (layout === "stacked-banded") {
            return(// mb-8 rounded-md md:mb-12 lg:mb-16
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 rounded-md md:mb-12 lg:mb-16 inner-wrapper bg-slate-100",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "max-w-4xl mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "px-4 pt-6 pb-8 mx-auto lg:pt-10 lg:pb-12 lg:flex lg:flex-col lg:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 prose-p:last-of-type:mb-0 max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            }));
        } else if (layout === "stacked-banded-full") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 bg-slate-100 md:mb-12 lg:mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "px-3 lg:mx-auto lg:max-w-4xl lg:px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex flex-col pt-6 pb-8 mx-auto lg:pt-10 lg:pb-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline prose-p:!mt-0 prose-p:last-of-type:mb-0 max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else {
            return null;
        }
    // Wide Layout -----
    } else {
        if (layout === "centered") {
            var ref2, ref3;
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "mx-auto prose text-center max-w-7xl md:prose-lg lg:prose-xl",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "tracking-tight text-gray-900 !mb-0",
                            children: title
                        }),
                        subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                            className: "tracking-tight text-brand-2-700 !mb-0",
                            children: subTitle
                        }),
                        text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                blocks: text
                            })
                        }),
                        (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col items-center justify-center gap-4 mt-8 text-center sm:flex-row md:gap-6 md:flex-none not-prose",
                            children: [
                                callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionPrimary.title,
                                    url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                    type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                    icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : (ref2 = callToActionPrimary.icon) === null || ref2 === void 0 ? void 0 : ref2.name,
                                    style: "primary",
                                    size: "lg",
                                    theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                    fullWidth: false
                                }),
                                callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                    url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                    type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                    icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : (ref3 = callToActionSecondary.icon) === null || ref3 === void 0 ? void 0 : ref3.name,
                                    style: "secondary",
                                    size: "lg",
                                    theme: "light",
                                    fullWidth: false
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (layout === "centered-branded") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "rounded-md bg-slate-100",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "max-w-3xl px-4 pt-6 pb-8 mx-auto prose text-center lg:pt-10 lg:pb-12 md:prose-lg lg:prose-xl",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                className: "tracking-tight text-gray-900 !mb-0",
                                children: title
                            }),
                            subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                className: "tracking-tight text-brand-2-700 !mb-0",
                                children: subTitle
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 text-lg lg:mx-auto lg:text-xl prose-p:text-gray-600 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col items-center justify-center gap-4 mt-8 text-center sm:flex-row md:gap-6 md:flex-none not-prose",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "centered-branded-full") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 bg-slate-100 md:mb-12 lg:mb-16 ",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "px-4 md:px-0 inner-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "max-w-3xl pt-6 pb-8 mx-auto prose text-center lg:pt-10 lg:pb-12 md:prose-lg lg:prose-xl",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                className: "tracking-tight text-gray-900 !mb-0",
                                children: title
                            }),
                            subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                className: "tracking-tight text-brand-2-700 !mb-0",
                                children: subTitle
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                    blocks: text
                                })
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col items-center justify-center gap-4 mt-8 text-center sm:flex-row md:gap-6 md:flex-none not-prose",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "justified") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "mx-auto rounded-md lg:flex lg:items-center lg:justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col prose md:prose-lg lg:prose-xl",
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "tracking-tight text-gray-900 !mb-0",
                                    children: title
                                }),
                                subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "tracking-tight text-brand-2-700 !mb-0",
                                    children: subTitle
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0 prose-p:last-of-type:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col gap-4 sm:flex-row md:gap-6 md:flex-none",
                            children: [
                                callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionPrimary.title,
                                    url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                    type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                    icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                    style: "primary",
                                    size: "lg",
                                    theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                    fullWidth: false
                                }),
                                callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                    url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                    type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                    icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                    style: "secondary",
                                    size: "lg",
                                    theme: "light",
                                    fullWidth: false
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (layout === "justified-branded") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "rounded-md bg-slate-100",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "px-4 pt-6 pb-8 mx-auto lg:px-10 lg:pt-10 lg:pb-12 lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0 prose-p:last-of-type:mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 lg:mt-0 md:gap-6 md:flex-none md:text-right",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "justified-branded-full") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 bg-slate-100 md:mb-12 lg:mb-16 ",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "inner-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "px-4 pt-6 pb-8 mx-auto lg:px-10 lg:pt-10 lg:pb-12 lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 lg:mx-auto prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0 prose-p:last-of-type:mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "stacked") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "mx-auto rounded-md lg:flex lg:flex-col ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col prose md:prose-lg lg:prose-xl",
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "tracking-tight text-gray-900 !mb-0",
                                    children: title
                                }),
                                subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "tracking-tight text-brand-2-700 !mb-0",
                                    children: subTitle
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0 prose-p:last-of-type:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                        blocks: text
                                    })
                                })
                            ]
                        }),
                        (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                            children: [
                                callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionPrimary.title,
                                    url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                    type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                    icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                    style: "primary",
                                    size: "lg",
                                    theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                    fullWidth: false
                                }),
                                callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                    title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                    url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                    type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                    icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                    style: "secondary",
                                    size: "lg",
                                    theme: "light",
                                    fullWidth: false
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (layout === "stacked-banded") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 rounded-md md:mb-12 lg:mb-16 inner-wrapper ",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "rounded-md bg-slate-100",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "px-4 pt-6 pb-8 mx-auto lg:px-10 lg:pt-10 lg:pb-12 lg:flex lg:flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0 prose-p:last-of-type:mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else if (layout === "stacked-banded-full") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "mb-8 bg-slate-100 md:mb-12 lg:mb-16",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "inner-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex flex-col pt-6 pb-8 mx-auto lg:pt-10 lg:pb-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col prose md:prose-lg lg:prose-xl",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                        className: "tracking-tight text-gray-900 !mb-0",
                                        children: title
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                        className: "tracking-tight text-brand-2-700 !mb-0",
                                        children: subTitle
                                    }),
                                    text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "mt-4 text-lg lg:text-xl prose-p:text-gray-500 prose-a:underline hover:prose-a:no-underline lg:max-w-prose prose-p:!mt-0 prose-p:last-of-type:mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serializers_text/* Text */.x, {
                                            blocks: text
                                        })
                                    })
                                ]
                            }),
                            (callToActionPrimary || callToActionSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col gap-4 mt-8 sm:flex-row md:gap-6 md:flex-none",
                                children: [
                                    callToActionPrimary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionPrimary.title,
                                        url: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.url,
                                        type: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type,
                                        icon: callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.icon,
                                        style: "primary",
                                        size: "lg",
                                        theme: (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "textIcon" || (callToActionPrimary === null || callToActionPrimary === void 0 ? void 0 : callToActionPrimary.type) === "text" ? "light" : "dark",
                                        fullWidth: false
                                    }),
                                    callToActionSecondary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(call_to_action/* CallToAction */.J, {
                                        title: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.title,
                                        url: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.url,
                                        type: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.type,
                                        icon: callToActionSecondary === null || callToActionSecondary === void 0 ? void 0 : callToActionSecondary.icon,
                                        style: "secondary",
                                        size: "lg",
                                        theme: "light",
                                        fullWidth: false
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        } else {
            return null;
        }
    }
}

;// CONCATENATED MODULE: ./components/layout/content-components/index.tsx



















var DynamicComponentWithNoSSRTikTok = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(936), __webpack_require__.e(4171)]).then(__webpack_require__.bind(__webpack_require__, 4171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4171)
            ];
        }
    },
    ssr: false
});
var DynamicComponentWithNoSSR = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3336), __webpack_require__.e(4146)]).then(__webpack_require__.bind(__webpack_require__, 4916));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4916)
            ];
        }
    },
    ssr: false
});


var content_components_builder = image_url_umd_default()(sanity_config/* config */.v);
function ContentManager(param) {
    var content = param.content, webform = param.webform, view = param.view, filter = param.filter, layout = param.layout;
    var ref;
    // console.clear()
    // console.log({content})
    // Hero
    if (content._type === "contentComponentHero") {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(hero/* Hero */.V, {
            layout: content === null || content === void 0 ? void 0 : content.layout,
            tagline: content === null || content === void 0 ? void 0 : content.tagline,
            title: content === null || content === void 0 ? void 0 : content.title,
            text: content === null || content === void 0 ? void 0 : content.text,
            primaryLinkText: content === null || content === void 0 ? void 0 : (ref1 = content.callToActionPrimary) === null || ref1 === void 0 ? void 0 : ref1.title,
            primaryLinkUrl: content === null || content === void 0 ? void 0 : (ref2 = content.callToActionPrimary) === null || ref2 === void 0 ? void 0 : ref2.url,
            primaryLinkIcon: content === null || content === void 0 ? void 0 : (ref3 = content.callToActionPrimary) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.icon) === null || ref4 === void 0 ? void 0 : ref4.name,
            primaryLinkType: content === null || content === void 0 ? void 0 : (ref5 = content.callToActionPrimary) === null || ref5 === void 0 ? void 0 : ref5.type,
            secondaryLinkText: content === null || content === void 0 ? void 0 : (ref6 = content.callToActionSecondary) === null || ref6 === void 0 ? void 0 : ref6.title,
            secondaryLinkUrl: content === null || content === void 0 ? void 0 : (ref7 = content.callToActionSecondary) === null || ref7 === void 0 ? void 0 : ref7.url,
            secondaryLinkIcon: content === null || content === void 0 ? void 0 : (ref8 = content.callToActionSecondary) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.icon) === null || ref9 === void 0 ? void 0 : ref9.name,
            secondaryLinkType: content === null || content === void 0 ? void 0 : (ref10 = content.callToActionSecondary) === null || ref10 === void 0 ? void 0 : ref10.type,
            altText: content === null || content === void 0 ? void 0 : (ref11 = content.heroImage) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.image) === null || ref12 === void 0 ? void 0 : ref12.alt,
            fullWidth: content === null || content === void 0 ? void 0 : content.fullWidth,
            image: content === null || content === void 0 ? void 0 : (ref13 = content.heroImage) === null || ref13 === void 0 ? void 0 : ref13.image,
            adjustedHeight: content === null || content === void 0 ? void 0 : content.height
        });
    // Feature
    } else if (content._type === "contentComponentFeature") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Feature, {
            layout: content.layout,
            title: content.title,
            tagline: content.tagline,
            text: content.text,
            featuretteStyle: content.featuretteLayout,
            featurettes: content.featurettes,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // Cards
    } else if (content._type === "contentComponentCardWrapper") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardWrapper, {
            layout: content.layout,
            title: content.title,
            tagline: content.tagline,
            text: content.text,
            cards: content.cards,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // Image
    } else if (content._type === "mainImage") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(image_ImageComponent, {
            content: content
        });
    // Image Gallery
    } else if (content._type === "imageGallery") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DynamicComponentWithNoSSR, {
            images: content.images,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // Image Gallery
    } else if (content._type === "slideshow") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Slideshow, {
            slides: content.slides
        });
    // Text Block
    } else if (content._type === "contentComponentTextBlock") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextWrapper, {
            body: content.body,
            fullWidth: (content === null || content === void 0 ? void 0 : content.fullWidth) || false,
            layout: layout || false,
            centerAlign: (content === null || content === void 0 ? void 0 : content.centerAlign) || false
        });
    // View Component
    } else if (content._type === "contentComponentView") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ViewComponent, {
            contentView: content.contentView,
            webform: webform,
            view: view,
            filter: filter,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // YouTube Video
    } else if (content._type === "youtube") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(YouTubeVideo, {
            url: content === null || content === void 0 ? void 0 : content.url,
            maxWidth: content === null || content === void 0 ? void 0 : content.maxWidth,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // Vimeo Video
    } else if (content._type === "vimeo") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(VimeoVideo, {
            url: content === null || content === void 0 ? void 0 : content.url,
            maxWidth: content === null || content === void 0 ? void 0 : content.maxWidth,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // Instagram Post
    } else if (content._type === "instagramPost") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstagramPost, {
            url: content.url
        });
    // TikTok Video
    } else if (content._type === "tikTokVideo") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DynamicComponentWithNoSSRTikTok, {
            url: content.url
        });
    // Iframe
    } else if (content._type === "iframe" && (content === null || content === void 0 ? void 0 : content.url)) {
        if (content === null || content === void 0 ? void 0 : content.centerAlign) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(iFrame/* Iframe */.h, (0,_object_spread/* default */.Z)({}, content))
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(iFrame/* Iframe */.h, (0,_object_spread/* default */.Z)({}, content))
            });
        }
    // PDF Embed
    } else if (content._type === "pdfFile" && content.file && content.file.asset && content.file.asset._ref) {
        if (content === null || content === void 0 ? void 0 : content.centerAlign) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full max-w-4xl px-3 mx-auto lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                    className: "mb-8 md:mb-12 lg:mb-16",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pdf/* PDF */.g, (0,_object_spread/* default */.Z)({}, content))
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pdf/* PDF */.g, (0,_object_spread/* default */.Z)({}, content))
            });
        }
    // PDF Embed
    } else if (content._type === "pdfFile" && content.file && content.file.asset && content.file.asset._ref) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
            className: "mb-8 md:mb-12 lg:mb-16 inner-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pdf/* PDF */.g, (0,_object_spread/* default */.Z)({}, content))
        });
    // Anchor
    } else if (content._type === "anchor" && (content === null || content === void 0 ? void 0 : (ref = content.anchorID) === null || ref === void 0 ? void 0 : ref.current)) {
        var ref14;
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
            id: content === null || content === void 0 ? void 0 : (ref14 = content.anchorID) === null || ref14 === void 0 ? void 0 : ref14.current
        });
    // Options Table
    } else if (content._type === "contentComponentOptionsTable") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionsTable, {
            layout: content === null || content === void 0 ? void 0 : content.layout,
            title: content === null || content === void 0 ? void 0 : content.title,
            tagline: content === null || content === void 0 ? void 0 : content.tagline,
            text: content === null || content === void 0 ? void 0 : content.text,
            icon: content === null || content === void 0 ? void 0 : content.listIcon,
            optionLayout: content === null || content === void 0 ? void 0 : content.optionLayout,
            optionListTitle: content === null || content === void 0 ? void 0 : content.optionListTitle,
            optionItems: content === null || content === void 0 ? void 0 : content.optionsItems,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // FAQ Section
    } else if (content._type === "contentComponentFAQSection") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FAQSection, {
            layout: content === null || content === void 0 ? void 0 : content.layout,
            title: content === null || content === void 0 ? void 0 : content.title,
            tagline: content === null || content === void 0 ? void 0 : content.tagline,
            text: content === null || content === void 0 ? void 0 : content.text,
            faqsLayout: content === null || content === void 0 ? void 0 : content.faqsLayout,
            faqs: content === null || content === void 0 ? void 0 : content.faqs,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign
        });
    // CTA Section
    } else if (content._type === "contentComponentCTASection") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CTASection, {
            layout: content === null || content === void 0 ? void 0 : content.layout,
            centerAlign: content === null || content === void 0 ? void 0 : content.centerAlign,
            title: content === null || content === void 0 ? void 0 : content.title,
            subTitle: content === null || content === void 0 ? void 0 : content.subTitle,
            text: content === null || content === void 0 ? void 0 : content.text,
            callToActionPrimary: content === null || content === void 0 ? void 0 : content.callToActionPrimary,
            callToActionSecondary: content === null || content === void 0 ? void 0 : content.callToActionSecondary
        });
    } else {
        return null;
    }
}
// "componentViewPosts"
function ContentComponents(props) {
    var contentComponents = props.contentComponents, webform = props.webform, view = props.view, filter = props.filter, layout = props.layout;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: contentComponents === null || contentComponents === void 0 ? void 0 : contentComponents.map(function(content) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ContentManager, {
                content: content,
                webform: webform,
                view: view,
                filter: filter,
                layout: layout
            }, content._key);
        })
    });
}
ContentComponents.propTypes = {
    contentComponents: (prop_types_default()).array,
    webform: (prop_types_default()).object,
    view: (prop_types_default()).object,
    filter: (prop_types_default()).string,
    layout: (prop_types_default()).bool
};


/***/ }),

/***/ 8038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./components/layout/footer/social-links.js
var social_links = __webpack_require__(6050);
// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(1056);
;// CONCATENATED MODULE: ./components/layout/footer/bottom-footer-nav.js


function BottomFooterNav(param) {
    var bottomFooterNav = param.bottomFooterNav;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
        className: "flex sm:ml-4",
        children: bottomFooterNav === null || bottomFooterNav === void 0 ? void 0 : bottomFooterNav.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                    url: link.siteLink,
                    classes: "mr-2 text-xs text-gray-200 md:text-sm hover:underline",
                    children: link.title
                })
            }, link._key);
        })
    });
}

// EXTERNAL MODULE: ./utils/helpers.ts
var helpers = __webpack_require__(949);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(3854);
;// CONCATENATED MODULE: ./components/layout/footer/index.js







var SubLinks = function(param) {
    var subLinks = param.subLinks;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                className: "text-sm font-semibold tracking-tight text-gray-200 uppercase",
                children: subLinks === null || subLinks === void 0 ? void 0 : subLinks.title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                className: "mt-4",
                children: subLinks === null || subLinks === void 0 ? void 0 : (ref = subLinks.links) === null || ref === void 0 ? void 0 : ref.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                        className: "mb-2 text-base text-gray-100",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                            url: link.siteLink,
                            classes: "hover:underline",
                            children: link.title
                        })
                    }, link._key);
                })
            })
        ]
    });
};
function hoursOfOperations(time) {
    if (time === null || time === void 0 ? void 0 : time.closed) {
        return "Closed";
    } else if ((time === null || time === void 0 ? void 0 : time.opensAt) && (time === null || time === void 0 ? void 0 : time.closesAt)) {
        return "".concat((0,helpers/* toggle24hr */.q0)(time === null || time === void 0 ? void 0 : time.opensAt, 0), " - ").concat((0,helpers/* toggle24hr */.q0)(time === null || time === void 0 ? void 0 : time.closesAt, 0));
    } else {
        return null;
    }
}
function Footer(param) {
    var topFooterNav = param.topFooterNav, bottomFooterNav = param.bottomFooterNav, siteSettings = param.siteSettings;
    var ref, ref1;
    var socialLinks = siteSettings.socialLinks, organizationDetails = siteSettings.organizationDetails;
    var gridCount = [];
    var hasContact = (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.address) || (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber) ? true : false;
    var hasHours = (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.operationHours) && (organizationDetails === null || organizationDetails === void 0 ? void 0 : (ref = organizationDetails.operationHours) === null || ref === void 0 ? void 0 : ref.length) >= 1 ? true : false;
    var hasSubLinks = topFooterNav === null || topFooterNav === void 0 ? void 0 : topFooterNav.some(function(vendor) {
        var ref;
        return ((ref = vendor["links"]) === null || ref === void 0 ? void 0 : ref.length) >= 1;
    });
    var subLinkArray = (topFooterNav === null || topFooterNav === void 0 ? void 0 : topFooterNav.map(function(vendor) {
        var ref;
        return ((ref = vendor["links"]) === null || ref === void 0 ? void 0 : ref.length) >= 1;
    }).filter(function(val) {
        return val === true;
    })) || [];
    gridCount = [
        hasContact,
        hasHours
    ].concat((0,_to_consumable_array/* default */.Z)(subLinkArray));
    gridCount = gridCount.filter(function(value) {
        return value;
    }).length;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("footer", {
        className: "text-gray-100 bg-brand-2-700 body-font",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "py-10 mx-auto inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "grid gap-6 md:grid-cols-".concat(gridCount >= 3 ? 2 : 1, " md:gap-10 lg:gap-8 lg:grid-cols-").concat(gridCount),
                    children: [
                        hasContact && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "text-sm font-semibold tracking-tight text-gray-200 uppercase",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "mt-4",
                                    children: [
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.address) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.address
                                        }),
                                        ((organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.city) || (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.state) || (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.zip)) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.city,
                                                " ",
                                                organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.state,
                                                " ",
                                                organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.zip
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.directionsMapURL) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "flex items-center mb-2 space-x-2 text-base text-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiLocationMarker */.XAC, {}),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.directionsMapURL,
                                                    classes: "hover:underline",
                                                    children: "Map and Directions"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "flex items-center mb-2 space-x-2 text-base text-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiMail */.hBs, {}),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/contact",
                                                    classes: "hover:underline",
                                                    children: "Email Us"
                                                })
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                "T: ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "tel:".concat(organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber),
                                                    classes: "hover:underline",
                                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber
                                                })
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumberSecondary) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                "T: ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "tel:".concat(organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumberSecondary),
                                                    classes: "hover:underline",
                                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumberSecondary
                                                })
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.faxNumber) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                "F: ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "tel:".concat(organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.faxNumber),
                                                    classes: "hover:underline",
                                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.faxNumber
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        hasHours && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "text-sm font-semibold tracking-tight text-gray-200 uppercase",
                                    children: "Hours"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                    className: "table w-full mt-4",
                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : (ref1 = organizationDetails.operationHours) === null || ref1 === void 0 ? void 0 : ref1.map(function(time) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "table-row text-base text-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                    className: "table-cell pb-1",
                                                    children: time.day
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                    className: "table-cell pb-1",
                                                    children: hoursOfOperations(time)
                                                })
                                            ]
                                        }, time._key);
                                    })
                                }),
                                (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.operationHoursNote) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "flex items-center mt-1 space-x-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiInformationCircle */.frK, {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "text-sm",
                                            children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.operationHoursNote
                                        })
                                    ]
                                })
                            ]
                        }),
                        hasSubLinks && (topFooterNav === null || topFooterNav === void 0 ? void 0 : topFooterNav.map(function(subLinks) {
                            return (subLinks === null || subLinks === void 0 ? void 0 : subLinks.links) && subLinks.links.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubLinks, {
                                subLinks: subLinks
                            }, subLinks._key);
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "bg-brand-2-800",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-col items-center px-5 py-6 mx-auto inner-wrapper sm:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "mt-4 ml-4 text-xs text-gray-200 md:text-sm sm:mt-0",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " ",
                                siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.title,
                                " - All Rights Reserved."
                            ]
                        }),
                        bottomFooterNav && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BottomFooterNav, {
                            bottomFooterNav: bottomFooterNav
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "grid justify-center grid-flow-col gap-2 auto-cols-max sm:ml-auto sm:mt-0",
                            children: socialLinks && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(social_links/* SocialLinks */.W, {
                                socialLinks: socialLinks
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 6050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SocialLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(949);
/* harmony import */ var _react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2916);
/* harmony import */ var _react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1362);
/* harmony import */ var _react_icons_all_files_fa_FaInstagram__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(681);
/* harmony import */ var _react_icons_all_files_fa_FaLinkedinIn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7951);
/* harmony import */ var _react_icons_all_files_fa_FaYoutube__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8320);
/* harmony import */ var _react_icons_all_files_fa_FaVimeoV__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4891);
/* harmony import */ var _react_icons_all_files_fa_FaPinterestP__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6625);
/* harmony import */ var _react_icons_all_files_fa_FaRedditAlien__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7443);
/* harmony import */ var _react_icons_all_files_fa_FaMediumM__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9061);
/* harmony import */ var _react_icons_all_files_fa_FaTwitch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(105);
/* harmony import */ var _react_icons_all_files_fa_FaDiscord__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2365);













function SocialIcon(socialType) {
    switch(socialType){
        case "facebook":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_2__/* .FaFacebookF */ .t, {});
            break;
        case "twitter":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_3__/* .FaTwitter */ .f, {});
            break;
        case "instagram":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaInstagram__WEBPACK_IMPORTED_MODULE_4__/* .FaInstagram */ .Z, {});
            break;
        case "linkedin":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaLinkedinIn__WEBPACK_IMPORTED_MODULE_5__/* .FaLinkedinIn */ .B, {});
            break;
        case "youtube":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaYoutube__WEBPACK_IMPORTED_MODULE_6__/* .FaYoutube */ .V, {});
            break;
        case "vimeo":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaVimeoV__WEBPACK_IMPORTED_MODULE_7__/* .FaVimeoV */ .H, {});
            break;
        case "tiktok":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 448 512",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                    d: "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                })
            });
            break;
        case "pinterest":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaPinterestP__WEBPACK_IMPORTED_MODULE_8__/* .FaPinterestP */ .c, {});
            break;
        case "reddit":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaRedditAlien__WEBPACK_IMPORTED_MODULE_9__/* .FaRedditAlien */ .V, {});
            break;
        case "medium":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaMediumM__WEBPACK_IMPORTED_MODULE_10__/* .FaMediumM */ .C, {});
            break;
        case "twitch":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaTwitch__WEBPACK_IMPORTED_MODULE_11__/* .FaTwitch */ .a, {});
            break;
        case "discord":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaDiscord__WEBPACK_IMPORTED_MODULE_12__/* .FaDiscord */ .j, {});
            break;
        default:
            return null;
    }
}
function SocialLinks(param) {
    var socialLinks = param.socialLinks;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: socialLinks.map(function(socialLink) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                href: socialLink.siteLink,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "px-1 py-3 text-2xl text-gray-300 transition-all hover:text-success",
                "aria-label": "Link to ".concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__/* .capitalizeFirstLetter */ .fm)(socialLink.socialType)),
                children: SocialIcon(socialLink.socialType)
            }, socialLink._key);
        })
    });
}


/***/ }),

/***/ 7821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/layout/logo/index.tsx


Logo.propTypes = {
    classes: (prop_types_default()).string,
    alt: (prop_types_default()).string,
    mode: (prop_types_default()).string || "light"
};
function Logo(props) {
    var classes = props.classes, alt = props.alt, mode = props.mode;
    var logoColor = mode === "dark" ? "#fff" : "#111";
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 417 141",
        className: classes,
        children: [
            alt && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("g", {
                fillRule: "nonzero",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        fill: "#F25F3F",
                        d: "m59.447.744 10.241 5.982-5.333 3.156L69.84 6.65v12.08L20.504 47.718v46.036l.048-.028 38.663 22.435 39.297-22.677V59.889L59.465 82.867v-.097l-10.104-6.004V64.863l-.21-.13 59.342-34.782 10.477 5.79.02-.012v.023l.01.006-.01.005v69.997l-59.186 34.881v.191l-.162-.096-.177.104v-.209L0 105.401V35.535l2.614 1.539-2.509-1.548z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        fill: "#F25F3F",
                        d: "M70.318 7.071v12.087L21.004 48.162V94.3l-10.186 5.867V42.171z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        fill: "#FFAA5B",
                        d: "M70.318 6.664 59.969.744 0 35.164l10.35 6.253zM119 94.254l-10.13-5.837-49.107 28.038-38.668-22.201-10.277 5.931 38.702 22.652 10.243 6.253zM119 36.317l-10.578-5.746-59.74 34.42 10.31 6.253z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        fill: "#EB1919",
                        d: "m0 35.994 10.319 6.081v57.783l49.181 28.78v12.202L0 105.561zM98.265 47.744v45.655l10.818 5.865V49.952l-10.818-2.208"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        fill: "#F25F3F",
                        d: "M59.5 140.84v-12.048l49.315-29.193V54.054L59.5 83.014V71.019L119 35.995v69.854z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        fill: "#EB1919",
                        d: "M48.682 64.014v12.674L59.5 82.994V70.447z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("g", {
                        fill: logoColor,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                            d: "M189.869 105.123c0 5.1-1.358 8.854-4.075 11.263-2.716 2.41-6.514 3.614-11.394 3.614-3.315 0-5.928-.234-7.838-.702-1.91-.468-3.35-.959-4.316-1.473l1.864-7.229c1.06.422 2.29.843 3.695 1.264 1.404.42 3.142.631 5.214.631 3.13 0 5.26-.69 6.388-2.07 1.128-1.38 1.692-3.31 1.692-5.79v-2.245h-.277c-1.611 2.199-4.465 3.298-8.563 3.298-4.466 0-7.792-1.403-9.979-4.21-2.187-2.807-3.28-7.205-3.28-13.193 0-6.27 1.473-11.018 4.42-14.246 2.946-3.228 7.228-4.842 12.844-4.842 2.947 0 5.583.21 7.908.632 2.325.42 4.224.912 5.697 1.473v33.825Zm-15.193-6.737c1.75 0 3.096-.398 4.04-1.193s1.669-1.988 2.175-3.579v-15.79c-1.427-.608-3.2-.912-5.317-.912-2.302 0-4.098.877-5.387 2.632-1.289 1.754-1.933 4.55-1.933 8.386 0 3.415.552 6.012 1.657 7.79 1.105 1.777 2.693 2.666 4.765 2.666Zm39.837-19.79c-1.428-.514-2.717-.771-3.868-.771-1.611 0-2.958.432-4.04 1.298-1.081.865-1.807 1.976-2.175 3.333v22.667h-8.977V70.035h6.975l1.035 4.632h.277c.782-1.731 1.841-3.065 3.176-4 1.335-.936 2.9-1.404 4.696-1.404 1.197 0 2.555.257 4.075.772l-1.174 8.561Zm2.752-6.526c1.842-.842 4.028-1.509 6.56-2 2.533-.491 5.18-.737 7.942-.737 2.394 0 4.397.293 6.008.878 1.612.584 2.89 1.415 3.833 2.49.944 1.077 1.611 2.363 2.003 3.86.391 1.497.587 3.182.587 5.053 0 1.647-.045 3.301-.133 4.963l-.075 1.248a112.152 112.152 0 0 0-.241 6.14 69.648 69.648 0 0 0 .172 5.86 22.382 22.382 0 0 0 1.036 5.368h-7.32l-1.45-4.842h-.345c-.921 1.45-2.199 2.702-3.833 3.754-1.634 1.053-3.74 1.58-6.319 1.58-1.611 0-3.061-.246-4.35-.738-1.29-.49-2.395-1.193-3.315-2.105a9.6 9.6 0 0 1-2.141-3.228c-.507-1.24-.76-2.632-.76-4.175 0-2.152.472-3.965 1.416-5.439.944-1.474 2.302-2.667 4.074-3.579 1.773-.912 3.89-1.544 6.354-1.895 2.463-.35 5.214-.456 8.252-.315.322-2.62.138-4.503-.552-5.65-.69-1.146-2.233-1.719-4.627-1.719-1.796 0-3.695.187-5.698.562-2.002.374-3.648.865-4.937 1.473l-2.14-6.807Zm11.395 26.105c1.795 0 3.222-.409 4.281-1.228 1.06-.818 1.842-1.696 2.348-2.631v-4.562a24.305 24.305 0 0 0-4.109-.07c-1.312.094-2.474.304-3.487.632-1.013.327-1.819.795-2.417 1.403-.599.608-.898 1.38-.898 2.316 0 1.31.38 2.328 1.14 3.053.76.725 1.806 1.087 3.142 1.087Zm20.845-28.14h6.56l1.037 4.21h.276c1.197-1.777 2.612-3.087 4.247-3.93 1.634-.841 3.625-1.262 5.973-1.262 4.328 0 7.574 1.391 9.738 4.175 2.163 2.784 3.245 7.263 3.245 13.439 0 2.994-.345 5.696-1.036 8.105-.69 2.41-1.715 4.456-3.073 6.14a13.456 13.456 0 0 1-4.972 3.86c-1.957.889-4.2 1.333-6.733 1.333-1.427 0-2.601-.105-3.522-.316-.92-.21-1.842-.55-2.762-1.017v14.386h-8.978V70.035Zm15.4 6.737c-1.75 0-3.119.444-4.109 1.333-.99.89-1.76 2.222-2.313 4v14.597a8.307 8.307 0 0 0 2.106 1.228c.76.304 1.76.456 3.004.456 2.578 0 4.512-.924 5.8-2.772 1.29-1.848 1.934-4.9 1.934-9.158 0-3.088-.506-5.474-1.519-7.158-1.013-1.684-2.647-2.526-4.903-2.526Zm40.803 28.35V85.194c0-2.854-.39-4.912-1.174-6.175-.782-1.264-2.21-1.895-4.281-1.895-1.52 0-2.912.526-4.178 1.579-1.266 1.052-2.106 2.397-2.52 4.035v22.386h-8.978V56h8.977v17.965h.276a12.54 12.54 0 0 1 4.075-3.579c1.611-.889 3.66-1.333 6.146-1.333 1.75 0 3.292.234 4.627.701a7.52 7.52 0 0 1 3.35 2.316c.897 1.076 1.564 2.538 2.002 4.386.437 1.848.656 4.129.656 6.842v21.825h-8.978Zm41.909-3.017c-1.382 1.123-3.258 2.07-5.629 2.842-2.37.772-4.891 1.158-7.561 1.158-5.571 0-9.645-1.649-12.224-4.947-2.578-3.298-3.867-7.825-3.867-13.58 0-6.175 1.45-10.806 4.35-13.894 2.901-3.088 6.976-4.631 12.224-4.631 1.75 0 3.453.234 5.11.701 1.658.468 3.13 1.24 4.42 2.316 1.29 1.076 2.325 2.526 3.108 4.351.782 1.825 1.174 4.094 1.174 6.807 0 .983-.058 2.035-.173 3.158a41.846 41.846 0 0 1-.518 3.509h-20.717c.138 2.947.886 5.17 2.244 6.666 1.358 1.497 3.556 2.246 6.595 2.246 1.888 0 3.58-.292 5.076-.877 1.496-.585 2.635-1.181 3.418-1.79l2.97 5.965Zm-12.845-25.754c-2.348 0-4.086.713-5.214 2.14-1.128 1.427-1.807 3.334-2.037 5.72h12.845c.184-2.527-.196-4.468-1.14-5.825-.944-1.357-2.428-2.035-4.454-2.035Zm68.416-7.298c1.75 0 3.453.234 5.11.701 1.658.468 3.131 1.24 4.42 2.316 1.29 1.076 2.325 2.526 3.108 4.351.783 1.825 1.174 4.094 1.174 6.807 0 .983-.058 2.035-.173 3.158a41.845 41.845 0 0 1-.518 3.509h-20.717c.138 2.947.886 5.17 2.244 6.666 1.359 1.497 3.557 2.246 6.595 2.246 1.888 0 3.58-.292 5.076-.877 1.496-.585 2.636-1.181 3.419-1.79l2.97 5.965c-1.382 1.123-3.258 2.07-5.63 2.842-2.37.772-4.89 1.158-7.561 1.158-5.57 0-9.645-1.649-12.223-4.947-2.578-3.298-3.867-7.825-3.867-13.58 0-6.175 1.45-10.806 4.35-13.894 2.9-3.088 6.975-4.631 12.223-4.631Zm-30.928 0c1.704 0 3.223.234 4.558.701a7.753 7.753 0 0 1 3.384 2.316c.92 1.076 1.611 2.538 2.072 4.386.46 1.848.69 4.129.69 6.842v21.825h-8.977v-19.93c0-2.854-.403-4.912-1.209-6.175-.805-1.264-2.175-1.895-4.109-1.895-1.703 0-3.142.503-4.316 1.509a8.387 8.387 0 0 0-2.52 3.754v22.737h-8.978V70.035h7.113l1.036 4.632h.276c1.06-1.497 2.463-2.807 4.213-3.93 1.75-1.123 4.005-1.684 6.767-1.684Zm30.79 7.298c-2.348 0-4.086.713-5.214 2.14-1.127 1.427-1.807 3.334-2.037 5.72h12.845c.184-2.527-.196-4.468-1.14-5.825-.943-1.357-2.428-2.035-4.454-2.035ZM159.989 29.872h2.406l.52 2.588h.188c1.164-2.109 2.99-3.163 5.475-3.163 2.485 0 4.35.943 5.592 2.827 1.243 1.885 1.864 4.968 1.864 9.25 0 2.012-.204 3.825-.613 5.439-.41 1.613-.991 2.987-1.746 4.121-.756 1.134-1.676 1.997-2.761 2.588-1.086.591-2.29.887-3.61.887-.913 0-1.637-.056-2.171-.168-.535-.112-1.117-.344-1.747-.695v9.872h-3.397V29.872Zm3.397 20.176c.44.383.936.687 1.487.91.55.224 1.282.336 2.194.336 1.668 0 2.99-.863 3.965-2.588.975-1.725 1.463-4.185 1.463-7.38 0-1.342-.087-2.556-.26-3.642-.173-1.087-.448-2.021-.826-2.804-.377-.783-.857-1.39-1.44-1.821-.581-.431-1.297-.647-2.146-.647-2.297 0-3.776 1.422-4.437 4.265v13.37Zm17.132-20.176h2.406l.614 2.54h.141c.441-.926 1.015-1.653 1.723-2.18.708-.528 1.565-.791 2.572-.791.724 0 1.542.144 2.454.431l-.66 3.498c-.819-.287-1.542-.43-2.171-.43-1.007 0-1.825.295-2.455.886-.629.59-1.038 1.382-1.227 2.372v17.636h-3.397V29.872Zm11.892 11.98c0-4.312.732-7.483 2.195-9.512 1.463-2.029 3.547-3.043 6.253-3.043 2.894 0 5.026 1.038 6.394 3.115 1.37 2.077 2.053 5.224 2.053 9.44 0 4.346-.739 7.525-2.218 9.537-1.478 2.013-3.555 3.02-6.23 3.02-2.894 0-5.025-1.039-6.394-3.115-1.368-2.077-2.053-5.224-2.053-9.441Zm3.54 0c0 1.407.086 2.685.26 3.835.172 1.15.455 2.14.849 2.97.393.832.904 1.479 1.534 1.942.629.463 1.384.695 2.265.695 1.636 0 2.863-.743 3.68-2.229.819-1.485 1.228-3.89 1.228-7.212 0-1.374-.087-2.644-.26-3.81-.173-1.166-.456-2.165-.85-2.995-.392-.83-.904-1.478-1.533-1.941-.63-.463-1.384-.695-2.265-.695-1.605 0-2.824.75-3.658 2.252-.833 1.502-1.25 3.898-1.25 7.189Zm18.5-11.98h3.397v25.255c0 3.291-.519 5.663-1.557 7.117-1.038 1.454-2.721 2.005-5.05 1.653v-3.115c.692 0 1.25-.143 1.676-.43.424-.288.755-.728.99-1.319.237-.59.386-1.326.449-2.204.063-.879.094-1.91.094-3.091V29.872Zm-.661-7.284c0-.767.212-1.39.637-1.87.425-.478.983-.718 1.675-.718.692 0 1.267.232 1.723.695.456.463.684 1.094.684 1.893 0 .767-.228 1.366-.684 1.797-.456.431-1.03.647-1.723.647-.692 0-1.25-.224-1.675-.671-.425-.447-.637-1.038-.637-1.773Zm24.304 29.616c-.755.703-1.714 1.246-2.879 1.63a11.692 11.692 0 0 1-3.68.575c-1.48 0-2.761-.296-3.847-.887-1.085-.591-1.982-1.438-2.69-2.54s-1.227-2.42-1.557-3.953c-.33-1.534-.496-3.26-.496-5.176 0-4.09.74-7.205 2.218-9.345 1.479-2.14 3.571-3.211 6.277-3.211.88 0 1.754.112 2.62.336.864.223 1.643.67 2.335 1.341.692.671 1.25 1.614 1.676 2.828.424 1.214.637 2.795.637 4.744 0 .543-.024 1.126-.071 1.75-.047.622-.102 1.27-.165 1.94h-11.987c0 1.374.11 2.62.33 3.738.22 1.118.566 2.069 1.038 2.852.472.782 1.078 1.39 1.817 1.82.74.432 1.66.648 2.761.648.85 0 1.691-.16 2.525-.48.834-.32 1.47-.702 1.911-1.15l1.227 2.54Zm-2.643-12.843c.063-2.396-.267-4.153-.99-5.272-.724-1.118-1.715-1.677-2.974-1.677-1.447 0-2.595.56-3.445 1.677-.85 1.119-1.353 2.876-1.51 5.272h8.92Zm20.671 13.274a7.91 7.91 0 0 1-2.69 1.342c-1.007.288-2.06.432-3.162.432-1.51 0-2.784-.296-3.823-.887-1.038-.591-1.88-1.438-2.524-2.54-.645-1.102-1.117-2.428-1.416-3.977-.3-1.55-.449-3.267-.449-5.152 0-4.09.716-7.205 2.148-9.345 1.431-2.14 3.484-3.211 6.158-3.211 1.227 0 2.281.112 3.162.336.881.223 1.636.51 2.266.862l-.944 3.02a8 8 0 0 0-4.106-1.103c-1.699 0-2.981.759-3.846 2.276-.865 1.518-1.298 3.906-1.298 7.165 0 1.31.094 2.54.283 3.69.189 1.15.503 2.148.944 2.995.44.847 1.007 1.518 1.699 2.013.692.495 1.557.743 2.596.743.818 0 1.58-.144 2.288-.432.708-.287 1.282-.623 1.723-1.006l.991 2.78Zm1.416-22.763h2.879v-4.744l3.397-1.102v5.846h5.097v3.115h-5.097v14.281c0 1.406.166 2.42.496 3.043.33.623.873.935 1.628.935.63 0 1.172-.072 1.628-.216a17.59 17.59 0 0 0 1.487-.551l.66 2.732a10.81 10.81 0 0 1-2.288.838 10.8 10.8 0 0 1-2.62.312c-1.573 0-2.697-.52-3.374-1.558-.676-1.038-1.014-2.723-1.014-5.056v-14.76h-2.88v-3.115Z"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(1056);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
;// CONCATENATED MODULE: ./components/layout/header/drop-down.js



function DropDown(param) {
    var link = param.link, classes = param.classes;
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,compat_module.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLinkState(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref = (0,compat_module.useState)(false), linkState = ref[0], setLinkState = ref[1];
    var wrapperRef = (0,compat_module.useRef)(null);
    useOutsideAlerter(wrapperRef);
    var handleClick = function() {
        setLinkState(function(linkState) {
            return !linkState;
        });
    // console.log(`linkState ${linkState === true ? 'true' : 'false'}`)
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "relative",
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                    onClick: function() {
                        return handleClick();
                    },
                    type: "button",
                    "aria-expanded": linkState,
                    className: "inline-flex items-center font-medium text-gray-500 bg-white rounded-md group hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ".concat(classes),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            children: link.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            className: "w-5 h-5 ml-2 text-gray-500 group-hover:text-gray-500",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                fillRule: "evenodd",
                                d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                clipRule: "evenodd"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "".concat(linkState === true ? "transform opacity-100 scale-100 visible absolute right-0 z-10 mt-2 origin-top-right rounded-md shadow-lg whitespace-nowrap min-w-[200px]" : "transform opacity-0 scale-95 invisible absolute right-0 z-10 mt-2 origin-top-right rounded-md shadow-lg whitespace-nowrap", " "),
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "px-2 py-2 text-right bg-white rounded-md shadow",
                        children: link.links.map(function(subLink) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                classes: "text-gray-600 block px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:shadow-outline transition-all",
                                url: subLink.siteLink,
                                children: subLink.title
                            }, subLink._key);
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/useUser.tsx
var useUser = __webpack_require__(3996);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/layout/header/mobile-nav.js
/* provided dependency */ var process = __webpack_require__(3454);







var DynamicComponentWithNoSSR = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7265).then(__webpack_require__.bind(__webpack_require__, 7265));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7265)
            ];
        }
    },
    ssr: false
});
function MobileNav(param) {
    var siteNav = param.siteNav, topNav = param.topNav, appLoginEnabled = param.appLoginEnabled;
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,compat_module.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLinkState(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref, ref1, ref2;
    var ref3 = (0,compat_module.useState)(false), linkState = ref3[0], setLinkState = ref3[1];
    var wrapperRef = (0,compat_module.useRef)(null);
    var Router = (0,router.useRouter)();
    var ref4 = (0,useUser/* useUser */.aF)(), isLoading = ref4.isLoading, subscription = ref4.subscription, userDetails = ref4.userDetails;
    useOutsideAlerter(wrapperRef);
    var handleClick = function() {
        setLinkState(function(linkState) {
            return !linkState;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "-my-2 lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                    type: "button",
                    "aria-expanded": linkState,
                    onClick: function() {
                        return handleClick();
                    },
                    className: "inline-flex items-center justify-center p-2.5 bg-white border border-white rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "sr-only",
                            children: "Open menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "aria-hidden": "true",
                            className: "w-6 h-6 text-gray-500",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "2",
                                d: "M4 6h16M4 12h16M4 18h16"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("nav", {
                className: "".concat(linkState === true ? "visible transform opacity-100 flex-col flex w-full mt-6 lg:hidden" : "transform opacity-0 hidden lg:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "lg:hidden",
                        children: siteNav.map(function(link) {
                            var ref;
                            if ((link === null || link === void 0 ? void 0 : (ref = link.links) === null || ref === void 0 ? void 0 : ref.length) >= 1) {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    className: "pb-4 mb-4 border-b-2 border-gray-100 last:border-none last:pb-0 last:mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "pt-1 pb-3 text-sm font-bold tracking-widest text-gray-700 uppercase",
                                            children: link.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "grid md:grid-cols-2 gap-y-4 gap-x-8",
                                            children: link.links.map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: link.siteLink,
                                                    classes: "text-base font-medium text-gray-500 hover:text-gray-900",
                                                    children: link.title
                                                }, link._key);
                                            })
                                        })
                                    ]
                                }, link._key);
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    className: "pb-4 mb-4 border-b-2 border-gray-100 last:border-none last:pb-0 last:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: link.siteLink,
                                        classes: "mb-6 text-base font-medium text-gray-500 hover:text-gray-900",
                                        children: link.title
                                    })
                                }, link._key);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("nav", {
                        className: "w-full pt-4 mt-4 border-t-2 border-gray-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                className: "grid mb-6 sm:grid-cols-2 gap-y-4 gap-x-8",
                                children: topNav.map(function(link) {
                                    var ref;
                                    if ((link === null || link === void 0 ? void 0 : (ref = link.links) === null || ref === void 0 ? void 0 : ref.length) >= 1) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "pb-4 mb-4 border-b-2 border-gray-100 last:border-none last:pb-0 last:mb-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                                    className: "pt-1 pb-3 text-sm font-bold tracking-widest text-gray-700 uppercase",
                                                    children: link.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                    className: "grid md:grid-cols-2 gap-y-4 gap-x-8",
                                                    children: link.links.map(function(link) {
                                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                            url: link.siteLink,
                                                            classes: "text-base font-medium text-gray-500 hover:text-gray-900",
                                                            children: link.title
                                                        }, link._key);
                                                    })
                                                })
                                            ]
                                        }, link._key);
                                    } else {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                            className: "pb-4 mb-4 border-b-2 border-gray-100 last:border-none last:pb-0 last:mb-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                url: link.siteLink,
                                                classes: "mb-6 text-base font-medium text-gray-500 hover:text-gray-900",
                                                children: link.title
                                            })
                                        }, link._key);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                                className: "grid grid-cols-2 mt-4 gap-y-4 gap-x-8",
                                children: [
                                    (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "https://vejbzqsykexhotgdfhul.supabase.co") && (process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTY0MTY0NDE4NCwiZXhwIjoxOTU3MjIwMTg0fQ.ux9tHgtRa2r46YGCheYKG60FD60iUjEXdXatv4Ss1T0") && appLoginEnabled === true && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                        children: [
                                            !isLoading && userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                            href: "/app/dashboard",
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                                className: "block w-full px-12 py-2 text-base font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                                children: "Dashboard"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                            url: "/api/auth/logout",
                                                            classes: "block text-center px-12 py-2 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-full",
                                                            children: "Logout"
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isLoading && !userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                            href: "/app/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                                className: "block w-full px-12 py-2 text-base font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                                children: "Login"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                            url: "/app/join",
                                                            classes: "block text-center px-12 py-2 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-full",
                                                            children: "Join"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (process === null || process === void 0 ? void 0 : (ref2 = process.env) === null || ref2 === void 0 ? void 0 : "OTY2NmQ4YWItOTM1NS00MTgzLThmZmQtNGUxMDhhMTRjYWU2NjM2MDQ1ODk4ODQxODIyNTgz") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                        className: "flex items-center col-span-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "block w-full px-4 py-2 text-base font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DynamicComponentWithNoSSR, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/layout/header/index.js
/* provided dependency */ var header_process = __webpack_require__(3454);








var header_DynamicComponentWithNoSSR = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7265).then(__webpack_require__.bind(__webpack_require__, 7265));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7265)
            ];
        }
    },
    ssr: false
});
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function TopLevelLink(param) {
    var link = param.link, classes = param.classes;
    var ref;
    if ((link === null || link === void 0 ? void 0 : (ref = link.links) === null || ref === void 0 ? void 0 : ref.length) >= 1) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropDown, {
            link: link,
            classes: classes
        }, link._key);
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                url: link.siteLink,
                classes: " font-medium text-gray-500 hover:text-gray-900 ".concat(classes),
                children: link.title
            })
        }, link._key);
    }
}
function Header(param) {
    var siteNav = param.siteNav, siteSettings = param.siteSettings, topNav = param.topNav;
    var ref, ref1, ref2, ref3;
    var title = siteSettings.title;
    var appLoginEnabled = siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.appSettings) === null || ref === void 0 ? void 0 : ref.appLoginEnabled;
    var ref4 = (0,useUser/* useUser */.aF)(), isLoading = ref4.isLoading, userDetails = ref4.userDetails;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "mb-6 md:mb-10 mt-2 inner-wrapper ".concat(topNav && topNav.length >= 1 ? "md:mt-4" : "md:mt-6"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("nav", {
                    className: "justify-end hidden w-full lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                        className: "flex space-x-4 mb-2",
                        children: [
                            topNav.map(function(link) {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TopLevelLink, {
                                    link: link,
                                    classes: "text-sm"
                                }, link._key);
                            }),
                            (header_process === null || header_process === void 0 ? void 0 : (ref1 = header_process.env) === null || ref1 === void 0 ? void 0 : "https://vejbzqsykexhotgdfhul.supabase.co") && (header_process === null || header_process === void 0 ? void 0 : (ref2 = header_process.env) === null || ref2 === void 0 ? void 0 : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTY0MTY0NDE4NCwiZXhwIjoxOTU3MjIwMTg0fQ.ux9tHgtRa2r46YGCheYKG60FD60iUjEXdXatv4Ss1T0") && appLoginEnabled === true && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    !isLoading && userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                className: "".concat(topNav && topNav.length >= 1 && "pl-4 ml-2 border-l border-slate-200"),
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                    href: "/app/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                        className: "px-2 py-1 text-sm font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                        children: "Dashboard"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/api/auth/logout",
                                                    classes: "text-center px-2 py-1 font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm",
                                                    children: "Logout"
                                                })
                                            })
                                        ]
                                    }),
                                    !isLoading && !userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                className: "".concat(topNav && topNav.length >= 1 && "pl-4 ml-2 border-l border-slate-200"),
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                    href: "/app/login",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                        className: "px-2 py-1 text-sm font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                        children: "Login"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/app/join",
                                                    classes: "text-center px-2 py-1 font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm",
                                                    children: "Join"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (header_process === null || header_process === void 0 ? void 0 : (ref3 = header_process.env) === null || ref3 === void 0 ? void 0 : "OTY2NmQ4YWItOTM1NS00MTgzLThmZmQtNGUxMDhhMTRjYWU2NjM2MDQ1ODk4ODQxODIyNTgz") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                className: "flex items-center space-x-1 text-lg text-gray-600",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header_DynamicComponentWithNoSSR, {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-wrap items-center justify-between mb-3 md:mb-4 lg:space-x-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "flex justify-start lg:w-0 lg:flex-1",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
                                url: "/",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "sr-only",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Logo, {
                                        classes: "w-auto h-8 md:h-10 xl:h-14",
                                        alt: "Logo",
                                        mode: "light"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("nav", {
                            className: "hidden lg:flex",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                className: "flex space-x-4 xlg:space-x-8",
                                children: siteNav.map(function(link) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TopLevelLink, {
                                        link: link
                                    }, link._key);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileNav, {
                            siteNav: siteNav,
                            topNav: topNav,
                            appLoginEnabled: appLoginEnabled || false
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 3304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8107);



function SEO(param) {
    var site = param.site, page = param.page, path = param.path;
    var ref;
    // console.log({ site, page, path })
    var pagePath = (path === null || path === void 0 ? void 0 : path.replace(/^\/|\/$/g, "")) || "";
    var ref1 = page || null, pageSEO = ref1.seoSettings;
    var siteSEO = site.seoSettings;
    var siteURL = (site === null || site === void 0 ? void 0 : (ref = site.siteURL) === null || ref === void 0 ? void 0 : ref.replace(/^\/|\/$/g, "")) || "";
    var url = pagePath && siteURL && siteURL + "/" + pagePath;
    var title = (pageSEO === null || pageSEO === void 0 ? void 0 : pageSEO.title) || (siteSEO === null || siteSEO === void 0 ? void 0 : siteSEO.title);
    // console.log({url})
    var description = (pageSEO === null || pageSEO === void 0 ? void 0 : pageSEO.description) || (siteSEO === null || siteSEO === void 0 ? void 0 : siteSEO.description);
    var openGraphImage = (pageSEO === null || pageSEO === void 0 ? void 0 : pageSEO.openGraphImage) || (siteSEO === null || siteSEO === void 0 ? void 0 : siteSEO.openGraphImage);
    var ogImage = (openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage._type) === "image" && (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .urlFor */ .uH)(openGraphImage).width(1200).url();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                httpEquiv: "x-ua-compatible",
                content: "ie=edge"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, shrink-to-fit=no"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("title", {
                children: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:creator",
                content: ""
            }),
            ogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: ogImage
            }),
            ogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:description",
                content: description
            }),
            ogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "twitter:image",
                content: ogImage
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "canonical",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "apple-mobile-web-app-status-bar",
                content: "#1F2937"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#f25f3f"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "msapplication-TileColor",
                content: "#1F2937"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "theme-color",
                content: "#1F2937"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "preconnect",
                href: "https://cdn.sanity.io"
            })
        ]
    });
}


/***/ }),

/***/ 1698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PreviewAlert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6896);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5506);



function PreviewAlert(param) {
    var asPath = param.asPath;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "bg-gray-800",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "py-2 inner-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: "flex flex-wrap items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: "flex items-center flex-1 w-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "flex p-2 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "w-4 h-4 text-white",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                className: "my-0 ml-3 text-sm font-medium text-white truncate",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    className: "md:inline",
                                    children: "You are in Preview Mode."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "w-auto mt-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                            href: "/api/exit-preview?slug=".concat(asPath),
                            className: "inline-flex items-center px-2 py-1 text-sm font-medium leading-4 text-white bg-gray-800 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                            children: [
                                "Exit Preview",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    className: "ml-2 -mr-0.5 h-4 w-4",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 7858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


function _interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
var React = _interopDefault(__webpack_require__(1720));
var reactIcons = __webpack_require__(8357);
var getIndexOfSecondUppercaseChar = function getIndexOfSecondUppercaseChar(text) {
    var index = 0;
    var numberOfUppercaseChars = 0;
    while(index <= text.length){
        if (text.charAt(index) === text.charAt(index).toUpperCase()) {
            numberOfUppercaseChars = numberOfUppercaseChars + 1;
        }
        if (numberOfUppercaseChars === 2) {
            break;
        }
        index = index + 1;
    }
    return index;
};
var loadIcons = function loadIcons(name) {
    var index = getIndexOfSecondUppercaseChar(name);
    if (index === name.length) return null;
    var iconLib = name.substring(0, index).toLowerCase();
    switch(iconLib){
        // case 'ai':
        //   return require('react-icons/ai');
        // case 'bs':
        //   return require('react-icons/bs');
        // case 'di':
        //   return require('react-icons/di');
        // case 'fa':
        //   return require('react-icons/fa');
        // case 'fc':
        //   return require('react-icons/fc');
        // case 'fi':
        //   return require('react-icons/fi');
        // case 'gi':
        //   return require('react-icons/gi');
        // case 'go':
        //   return require('react-icons/go');
        // case 'gr':
        //   return require('react-icons/gr');
        // case 'io':
        //   return require('react-icons/io');
        // case 'md':
        //   return require('react-icons/md');
        // case 'ri':
        //   return require('react-icons/ri');
        // case 'ti':
        //   return require('react-icons/ti');
        // case 'wi':
        //   return require('react-icons/wi');
        // case 'io5':
        //   return require('react-icons/io5');
        case "hi":
            return __webpack_require__(5898);
        // case 'si':
        //   return require('react-icons/si');
        // case 'im':
        //   return require('react-icons/im');
        // case 'bi':
        //   return require('react-icons/bi');
        // case 'cg':
        //   return require('react-icons/cg');
        // case 'cg':
        //   return require('react-icons/cg');
        default:
            return null;
    }
};
var getIcon = function getIcon(name) {
    var icons = loadIcons(name);
    if (!icons) return null;
    return icons[name];
};
var Icon = function Icon(_ref) {
    var name = _ref.name, color = _ref.color, size = _ref.size, className = _ref.className, style = _ref.style;
    var Icon = name ? getIcon(name) : null;
    return /*#__PURE__*/ React.createElement(reactIcons.IconContext.Provider, {
        value: {
            color: color,
            size: size,
            className: className,
            style: style
        }
    }, name && Icon && /*#__PURE__*/ React.createElement(Icon, null));
};
module.exports = Icon;


/***/ }),

/***/ 6487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export displayIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(782);
/* harmony import */ var _react_icons_all_files_fa_FaExclamationCircle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5467);
/* harmony import */ var _react_icons_all_files_fa_FaBug__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5438);
/* harmony import */ var _react_icons_all_files_fa_FaExclamationTriangle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3492);
/* harmony import */ var _react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5229);
/* harmony import */ var _react_icons_all_files_fa_FaInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9365);









var displayIcon = function(type) {
    switch(type){
        case "success":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_3__/* .FaCheck */ .l, {});
        case "info":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaInfo__WEBPACK_IMPORTED_MODULE_4__/* .FaInfo */ .L, {});
        case "error":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaExclamationCircle__WEBPACK_IMPORTED_MODULE_5__/* .FaExclamationCircle */ .a, {});
        case "warning":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaExclamationTriangle__WEBPACK_IMPORTED_MODULE_6__/* .FaExclamationTriangle */ .g, {});
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaBug__WEBPACK_IMPORTED_MODULE_7__/* .FaBug */ .i, {});
    }
};
var ToastMessage = function(param) {
    var type = param.type, message = param.message;
    return react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast */ .Am[type](/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                style: {
                    fontSize: 15,
                    paddingTop: 8,
                    flexShrink: 0,
                    textAlign: "center",
                    width: "30px",
                    color: "white"
                },
                children: displayIcon(type)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                style: {
                    flexGrow: 1,
                    fontSize: 15,
                    padding: "8px 12px",
                    color: "#333"
                },
                children: message
            })
        ]
    }));
};
ToastMessage.propTypes = {
    message: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired)
};
ToastMessage.dismiss = react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.dismiss */ .Am.dismiss;
/* harmony default export */ __webpack_exports__["Z"] = (ToastMessage);


/***/ }),

/***/ 949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "AK": function() { return /* binding */ classNames; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "n8": function() { return /* binding */ transformToUpperCase; },
/* harmony export */   "q0": function() { return /* binding */ toggle24hr; },
/* harmony export */   "qC": function() { return /* binding */ postData; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony exports hasWhiteSpace, isObject, LabelFilter, isNumber, toCurrency, portableTextToPlainText, scaledImageURL, TimeConvert, getURL, toDateTime, isEmptyObject, secondsToTime, camalize, postDataNew */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(655);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8107);
/* provided dependency */ var process = __webpack_require__(3454);




function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function hasWhiteSpace(s) {
    return s.indexOf(" ") >= 0;
}
function capitalizeFirstLetter(string) {
    var ref;
    return string ? ((ref = string[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (string === null || string === void 0 ? void 0 : string.slice(1)) : null;
}
function transformToUpperCase(str, separators) {
    if (typeof str === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(str, String)) {
        separators = separators || [
            " "
        ];
        var regex = new RegExp("(^|[" + separators.join("") + "])(\\w)", "g");
        return "Hi" + str.toLowerCase().replace(regex, function(x) {
            return x.toUpperCase();
        }).replace(/-/g, "");
    }
    return null;
}
function toggle24hr(time, onoff) {
    if (onoff == undefined) onoff = isNaN(time.replace(":", "")) //auto-detect format
    ;
    var pm = time.toString().toLowerCase().indexOf("pm") > -1 //check if 'pm' exists in the time string
    ;
    time = time.toString().toLowerCase().replace(/[ap]m/, "").split(":") //convert time to an array of numbers
    ;
    time[0] = Number(time[0]);
    if (onoff) {
        if (pm && time[0] != 12) time[0] += 12;
        else if (!pm && time[0] == 12) time[0] = "00" //handle midnight
        ;
        if (String(time[0]).length == 1) time[0] = "0" + time[0] //add leading zeros if needed
        ;
    } else {
        pm = time[0] >= 12;
        if (!time[0]) time[0] = 12 //handle midnight
        ;
        else if (pm && time[0] != 12) time[0] -= 12;
    }
    return onoff ? time.join(":") : time.join(":") + (pm ? "pm" : "am");
}
var truncate = function(input) {
    return (input === null || input === void 0 ? void 0 : input.length) > 300 ? "".concat(input.substring(0, 325), "...") : input;
};
function isObject(val) {
    if (val === null) {
        return false;
    }
    return typeof val === "function" || typeof val === "object";
}
function LabelFilter(val) {
    // Replaces '_' with a space and capitalizes the first lettter of each word
    return val.replace(/_/g, " ").split(" ").map(function(val) {
        return val[0].toUpperCase() + val.substring(1);
    }).join(" ");
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}
function toCurrency(numberString) {
    if (!isNumber) {
        return null;
    } else {
        return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "USD",
            currencyDisplay: "narrowSymbol"
        }).format(numberString);
    }
}
function portableTextToPlainText() {
    var blocks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return blocks// loop through each block
    .map(function(block) {
        // if it's not a text block with children,
        // return nothing
        if (block._type !== "block" || !block.children) {
            return "";
        }
        // loop through the children spans, and join the
        // text strings
        return block.children.map(function(child) {
            return child.text;
        }).join("");
    })// join the paragraphs leaving split by two linebreaks
    .join("\n\n");
}
var scaledImageURL = function(val, height, width) {
    return val ? "".concat(urlFor(val).auto("format").width(height || 800).height(width || 600).url()) : null;
};
function TimeConvert(n) {
    var dminutes = function dminutes(min) {
        if (min === 0) {
            return "";
        } else if (min === 1) {
            return min + " and minute ";
        } else {
            return min + " and minutes ";
        }
    };
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    var dhours = rhours > 1 ? rhours + " hours " : rhours + " hour ";
    // rminutes > 1 ? rminutes + " minutes " :
    return dhours + dminutes(rminutes);
}
function isEmpty(value) {
    return value == null || value === "" || value === undefined;
}
var getURL = function() {
    var ref, ref1, ref2, ref3;
    var url = (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "https://www.project-graphene.com") && (process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : "https://www.project-graphene.com") !== "" ? "https://www.project-graphene.com" : (process === null || process === void 0 ? void 0 : (ref2 = process.env) === null || ref2 === void 0 ? void 0 : ref2.VERCEL_URL) && (process === null || process === void 0 ? void 0 : (ref3 = process.env) === null || ref3 === void 0 ? void 0 : ref3.VERCEL_URL) !== "" ? process.env.VERCEL_URL : "http://localhost:3000";
    return url.includes("http") ? url : "https://".concat(url);
};
var postData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var url, data, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, data = param.data;
                    console.log("posting,", url, data);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: new Headers({
                                "Content-Type": "application/json"
                            }),
                            credentials: "same-origin",
                            body: JSON.stringify(data)
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        console.log("Error in postData", {
                            url: url,
                            data: data,
                            res: res
                        });
                        console.log({
                            res: res
                        });
                        console.log({
                            data: data
                        });
                        throw Error(res.statusText);
                    }
                    return [
                        2,
                        res.json()
                    ];
            }
        });
    });
    return function postData(_) {
        return _ref.apply(this, arguments);
    };
}();
var postDataNew = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var url, data, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, data = param.data;
                    console.log("posting,", url, data);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: new Headers({
                                "Content-Type": "application/json"
                            }),
                            credentials: "same-origin",
                            body: JSON.stringify(data)
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        console.log("Error in postData", {
                            url: url,
                            data: data,
                            res: res
                        });
                        console.log({
                            res: res
                        });
                        console.log({
                            data: data
                        });
                        throw Error(res.statusText);
                    }
                    return [
                        2,
                        res.json()
                    ];
            }
        });
    });
    return function postDataNew(_) {
        return _ref.apply(this, arguments);
    };
}();
var toDateTime = function(secs) {
    var t = new Date("1970-01-01T00:30:00Z"); // Unix epoch start.
    t.setSeconds(secs);
    return t;
};
var isEmptyObject = function(object) {
    for(var property in object){
        return false;
    }
    return true;
};
var secondsToTime = function(e) {
    var h = Math.floor(e / 3600).toString().padStart(2, "0"), m = Math.floor(e % 3600 / 60).toString().padStart(2, "0"), s = Math.floor(e % 60).toString().padStart(2, "0");
    return "".concat(h, ":").concat(m, ":").concat(s);
};
var camalize = function(str) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(m, chr) {
        return chr.toUpperCase();
    });
};



/***/ })

}]);